<template>

     <!-- Raiz da aplicação Vuetify -->
    <v-app> 

        <!-- Área principal da aplicação -->
        <v-main> 
        
            <!-- Barra preta -->
            <v-toolbar
                color="black"
                dense
                flat
                :style="{
                    'border-top-left-radius': '12px',
                    'border-top-right-radius': '8px',
                    'position': 'fixed',
                    'top': '64px',
                    'left': modoBarraLateral ? '70px' : '260px',
                    'width': modoBarraLateral ? 'calc(100% - 70px)' : 'calc(100% - 260px)',
                    'z-index': '999',
                    'transition': 'left 0.3s ease, width 0.3s ease'
                }"
            >                      
                <v-toolbar-title class="white--text">Cadastro Empresa</v-toolbar-title> 
                <v-spacer />

            </v-toolbar>

            <!-- Conteúdo com espaçamento -->
            <v-container fluid class="pa-4">

                <!-- Card que agrupa elementos do formulário  -->
                <v-card class="pa-4" style="width: 100%; top: 60px;">

                    <!-- Formulário de cadastro da empresa -->
                    <v-form ref="formCadastroEmpresa" v-model="validaCadastroEmpresa">
                    
                        <v-row>
                        
                            <!-- Campo nome fantasia -->
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    label="Empresa" 
                                    v-model="dadosEmpresa.nomeFantasia"
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>
                        
                            <!-- Campo razão social -->
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    label="Razão Social" 
                                    v-model="dadosEmpresa.razaoSocial"
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>
                        
                            <!-- Campo apelido -->
                            <v-col cols="12" md="2">
                                <v-text-field 
                                    label="Apelido" 
                                    maxlength="45"
                                    v-model="dadosEmpresa.apelido" 
                                    v-uppercase
                                />
                            </v-col>

                            <!-- Campo custo hora -->
                            <v-col cols="12" md="2">
                                <v-text-field 
                                    label="Custo Hora" 
                                    v-model="dadosEmpresa.custoHora" 
                                    @input="formatarValorCustoHora"
                                    maxlength="15"
                                    clearable
                                />
                            </v-col>

                        </v-row>

                        <v-row>
                        
                            <!-- Campo  cnpj -->
                            <v-col cols="12" md="4">                        
                                <v-text-field
                                    label="CNPJ"
                                    v-model="dadosEmpresa.cnpj"
                                    :rules="[rules.required]"
                                    v-cnpj-mask
                                    @blur="validarCnpj(dadosEmpresa.cnpj)"
                                    ref="focoCNPJ"
                                />
                            </v-col>

                            <!-- Campo inscrição estadual -->
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    label="Inscrição Estadual"
                                    maxlength="45" 
                                    v-model="dadosEmpresa.inscricaoEstadual"
                                    :rules="[rules.required]" 
                                    v-numerico
                                />
                            </v-col>

                            <!-- Campo inscrição estadual -->
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    label="Inscrição Municipal"
                                    maxlength="45" 
                                    v-model="dadosEmpresa.inscricaoMunicipal"
                                    v-numerico 
                                />
                            </v-col>
                        
                        </v-row>

                        <v-row>

                            <!-- Campo ramo de atividade -->
                            <v-col cols="12" md="4">              
                                <v-select
                                    label="Ramo de Atividade"
                                    v-model="dadosEmpresa.idRamoAtividade"
                                    :items="listaRamosAtividade"
                                    item-title="nome"
                                    item-value="idRamoAtividade"
                                    :rules="[rules.required]"
                                />                
                            </v-col>

                            <!-- Campo status crédito -->
                            <v-col cols="12" md="2">
                                <v-select
                                    label="Status de Crédito"
                                    :items="listaStatusCredito"
                                    v-model="dadosEmpresa.idStatusCredito"
                                    item-title="nome"
                                    item-value="idStatusCredito"
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            
                            <!-- Campo site -->
                            <v-col cols="12" md="3">
                                <v-text-field 
                                    label="Site" 
                                    maxlength="1024"
                                    v-model="dadosEmpresa.urlSite" 
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            
                            <!-- Campo email principal -->
                            <v-col cols="12" md="3">
                                <v-text-field 
                                    label="E-mail" 
                                    maxlength="1024"
                                    v-model="dadosEmpresa.emailPrincipal" 
                                    :rules="[rules.required]"
                                />
                            </v-col>
                            
                        </v-row>

                        <v-row>
                            
                            <!-- Campo fone principal -->
                            <v-col cols="12" md="3">
                                <v-text-field 
                                    label="Fone Principal"
                                    maxlength="45" 
                                    v-model="dadosEmpresa.fonePrincipal" 
                                    v-telefone
                                    :rules="[rules.required]"
                                />
                            </v-col>

                            <!-- Campo cep -->
                            <v-col cols="12" md="3">
                                <v-text-field   
                                    label="CEP" 
                                    v-model="dadosEmpresa.cep"
                                    maxlength="9"
                                    :rules="[rules.required]"
                                    v-numerico 
                                    @blur="buscaCep(dadosEmpresa.cep)"
                                />
                            </v-col>
                            
                            <!-- Campo pais -->
                            <v-col cols="12" md="3">
                                <v-text-field 
                                    label="País" 
                                    v-model="dadosEmpresa.pais"
                                    maxlength="45"
                                    :rules="[rules.required]" 
                                    v-uppercase
                                />
                            </v-col>
                            
                            <!-- Campo uf -->
                            <v-col cols="8" md="1">
                                <v-text-field 
                                    label="UF" 
                                    v-model="dadosEmpresa.uf"
                                    maxlength="2"
                                    :rules="[rules.required]" 
                                    v-uppercase
                                />
                            </v-col>

                            <!-- Campo cidade -->
                            <v-col cols="12" md="2">
                                <v-text-field 
                                    label="Cidade" 
                                    v-model="dadosEmpresa.cidade"
                                    maxlength="255"
                                    :rules="[rules.required]" 
                                    v-uppercase
                                />
                            </v-col>

                        </v-row>

                        <v-row>

                            <!-- Campo bairro -->
                            <v-col cols="12" md="3">
                                <v-text-field 
                                    label="Bairro" 
                                    v-model="dadosEmpresa.bairro"
                                    maxlength="255"
                                    :rules="[rules.required]" 
                                    v-uppercase
                                />
                            </v-col>

                            <!-- Campo logradouro -->
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    label="Logradouro" 
                                    v-model="dadosEmpresa.logradouro"
                                    maxlength="255"
                                    :rules="[rules.required]" 
                                    v-uppercase
                                />
                            </v-col>
                        
                            <!-- Campo número -->
                            <v-col cols="12" md="1">
                                <v-text-field 
                                    label="Número" 
                                    v-model="dadosEmpresa.numero"
                                    maxlength="6"
                                    :rules="[rules.required]" 
                                    v-numerico
                                    ref="focoNumero"
                                />
                            </v-col>
                        
                            <!-- Campo complemento -->
                            <v-col cols="12" md="4">
                                <v-text-field 
                                    label="Complemento" 
                                    v-model="dadosEmpresa.complemento" 
                                    maxlength="45"                                    
                                    v-uppercase
                                />
                            </v-col>

                        </v-row>

                        <v-row>

                            <!-- seleção empresa de manutenção -->
                            <v-col cols="12" md="4" class="d-flex align-center">
                                <v-switch
                                    v-model="dadosEmpresa.empresaManutencao"
                                    :label="dadosEmpresa.empresaManutencao ? 'Suporte Técnico' : 'Cliente'"
                                    :color="dadosEmpresa.empresaManutencao ? 'blue' : 'white'"
                                />
                            </v-col>
                            
                            <!-- Campo emissora televisão -->
                            <v-col cols="12" md="4" class="d-flex align-center">
                                <v-switch
                                    v-model="dadosEmpresa.emissoraTelevisao"
                                    :label="dadosEmpresa.emissoraTelevisao ? 'Emissora Televisão' : 'Empresa Outra'"
                                    :color="dadosEmpresa.emissoraTelevisao ? 'blue' : 'white'"
                                />
                            </v-col>
                            
                            <!-- Campo ativo -->
                            <v-col cols="12" md="4" class="d-flex align-center">
                                <v-switch
                                    :label="dadosEmpresa.ativo ? 'Ativo' : 'Inativo'"
                                    :color="dadosEmpresa.ativo ? 'blue' : 'white'"
                                    v-model="dadosEmpresa.ativo"
                                />
                            </v-col>

                        </v-row>

                    </v-form>

                    <!-- Acordeon com lista de colaboradores da empresa -->
                    <v-expansion-panels 
                        v-model="acordeonColaboradores" 
                        v-show="idEmpresaRecebido > 0"
                        id="acordeonColaboradores"
                        style="margin-bottom: 16px;"
                    >

                        <v-expansion-panel>

                            <v-expansion-panel-title>
                                Colaboradores
                                <span v-if="totalColaboradores > 0" class="text-caption ml-1">
                                    ({{ totalColaboradores }})
                                </span>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>

                                <v-row class="mb-4" align="center" justify="end">

                                    <!-- Botão para criar novo colaborador -->
                                    <v-col cols="auto">
                                    
                                        <v-tooltip text="Novo Colaborador" location="top">
                                        
                                            <template #activator="{ props }">
                                                <v-btn
                                                    v-bind="props"
                                                    icon
                                                    size="small"
                                                    class="rounded-button"
                                                    style="background-color: #4CAF50;"
                                                    @click="novoColaborador"
                                                >
                                                    <v-icon color="white">mdi-plus</v-icon>
                                                </v-btn>                
                                            </template>
                                        
                                        </v-tooltip>

                                    </v-col>

                                </v-row>

                                <!-- Campo de busca colaboradores empresa -->
                                <v-text-field
                                    v-model="textoBuscaColaboradorEmpresa"
                                    label="Pesquisar"
                                    placeholder="Digite sua busca..."
                                    prepend-inner-icon="mdi-magnify"
                                    variant="outlined"
                                    clearable
                                    @keyup.enter="carregarListaColaboradoresEmpresa"
                                    @click:clear="carregarListaColaboradoresEmpresa"
                                    @update:modelValue="onBuscaColaboradorAtualizada"
                                />

                                <!-- Lista de colaboradores do modal de cadastro de empresas -->
                                <v-data-table-server
                                    item-value="idColaborador"
                                    v-model:options="opcoesTabelaColaboradoresEmpresa"
                                    :headers="headersColaboradores"
                                    :items="listaColaboradores"
                                    :loading="carregandoColaboradores"
                                    @update:options="carregarListaColaboradoresEmpresa"
                                    class="elevation-2 rounded-lg"
                                    density="compact"
                                    :items-length="totalColaboradores"
                                    :footer-props="{
                                        'items-per-page-text': 'Itens por página'
                                    }" 
                                    :style="{ 
                                        'font-family': 'Arial, sans-serif !important', 
                                        'font-size': '12px !important' 
                                    }"                                   
                                >
                                    
                                    <template v-slot:item.funcoes="{ item }">
                    
                                        <!-- Ícone de atalho para editar chamado -->
                                        <v-tooltip text="Editar Colaborador" location="bottom">
                                            <template #activator="{ props }">
                                                <v-icon
                                                    v-bind="props"
                                                    :color="item.ativo === 1 ? 'green' : 'red'" 
                                                    size="24" 
                                                    @click="editarColaboradorEmpresa(item.id)"
                                                    style="cursor: pointer; margin-right: 8px;"
                                                >
                                                mdi-pencil
                                                </v-icon>
                                            </template>
                                        </v-tooltip>
                                        
                                    </template>
                                    
                                    <!-- Coluna Condição (Ativo/Inativo) -->
                                    <template #item.ativo="{ item }">
                                        <span :class="item.ativo === 1 ? 'text-green' : 'text-red'">
                                        {{ item.ativo === 1 ? 'Ativo' : 'Inativo' }}
                                        </span>
                                    </template>
                                    
                                </v-data-table-server>

                            </v-expansion-panel-text>

                        </v-expansion-panel>

                    </v-expansion-panels>

                    <!-- Acordeon com lista de produtos da empresa -->
                    <v-expansion-panels
                        v-if="!dadosEmpresa.emissoraTelevisao" 
                        v-model="acordeonProdutosEmpresa" 
                        v-show="idEmpresaRecebido > 0"
                        id="acordeonProdutosEmpresa"
                        style="margin-bottom: 16px;"
                    >

                        <v-expansion-panel>

                            <v-expansion-panel-title>
                                Produtos
                                <span v-if="totalProdutosEmpresa > 0" class="text-caption ml-1">
                                    ({{ totalProdutosEmpresa }})
                                </span>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>

                                <v-row class="mb-4" align="center" justify="end">

                                    <!-- Botão para criar novo produto para a empresa -->
                                    <v-col cols="auto">
                                    
                                        <v-tooltip text="Novo Produto" location="top">
                                        
                                            <template #activator="{ props }">
                                                <v-btn
                                                    v-bind="props"
                                                    icon
                                                    size="small"
                                                    class="rounded-button"
                                                    style="background-color: #4CAF50;"
                                                    @click="novoProdutoEmpresa"
                                                >
                                                    <v-icon color="white">mdi-plus</v-icon>
                                                </v-btn>                
                                            </template>
                                        
                                        </v-tooltip>

                                    </v-col>
                                    
                                </v-row>

                                <!-- Campo de busca produtos empresa -->
                                <v-text-field
                                    v-model="textoBuscaProdutosEmpresa"
                                    label="Pesquisar"
                                    placeholder="Digite sua busca..."
                                    prepend-inner-icon="mdi-magnify"
                                    variant="outlined"
                                    clearable
                                    @keyup.enter="carregarListaProdutosEmpresa"
                                    @click:clear="carregarListaProdutosEmpresa"
                                    @update:modelValue="atualizaParamentrosBuscaProdutosEmpresa"
                                />

                                <!-- Lista de produtos do modal de cadastro de empresas -->
                                <v-data-table-server
                                    item-value="idProdutoEmpresa"
                                    v-model:options="opcoesTabelaProdutosEmpresa"
                                    :headers="headersProdutosEmpresa"
                                    :items="listaProdutosEmpresa"
                                    :loading="carregandoProdutosEmpresa"
                                    @update:options="carregarListaProdutosEmpresa"
                                    class="elevation-2 rounded-lg"
                                    :items-length="totalProdutosEmpresa"
                                    :footer-props="{
                                        'items-per-page-text': 'Itens por página'
                                    }" 
                                    :style="{ 
                                        'font-family': 'Arial, sans-serif !important', 
                                        'font-size': '12px !important' 
                                    }"                                    
                                >
                                    
                                    <template v-slot:item.funcoes="{ item }">
                    
                                        <!-- Ícone de atalho para editar produto -->
                                        <v-tooltip text="Editar Produto" location="bottom">
                                            <template #activator="{ props }">
                                                <v-icon
                                                    v-bind="props"
                                                    :color="item.ativo === 1 ? 'green' : 'red'" 
                                                    size="24" 
                                                    @click="editarProdutoEmpresa(item.id)"
                                                    style="cursor: pointer; margin-right: 8px;"
                                                >
                                                mdi-pencil
                                                </v-icon>
                                            </template>
                                        </v-tooltip>
                                        
                                    </template>
                                    
                                    <!-- Coluna Condição (Ativo/Inativo) -->
                                    <template #item.ativo="{ item }">
                                        <span :class="item.ativo === 1 ? 'text-green' : 'text-red'">
                                            {{ item.ativo === 1 ? 'Ativo' : 'Inativo' }}
                                        </span>
                                    </template>
                                    
                                </v-data-table-server>

                            </v-expansion-panel-text>

                        </v-expansion-panel>

                    </v-expansion-panels>

                    <!-- Acordeon com lista de setores da empresa -->
                    <v-expansion-panels 
                        v-if="loginStore.emissoraTelevisao === 1"
                        v-model="acordeonSetoresEmpresa" 
                        v-show="idEmpresaRecebido > 0"
                        id="acordeonSetoresEmpresa"
                    >

                        <v-expansion-panel>

                            <v-expansion-panel-title>
                                Setores
                                <span v-if="totalSetoresEmpresa > 0" class="text-caption ml-1">
                                    ({{ totalSetoresEmpresa }})
                                </span>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>

                                <v-row class="mb-4" align="center" justify="end">

                                    <!-- Botão para criar novo setor para a empresa -->
                                    <v-col cols="auto">
                                    
                                        <v-tooltip text="Novo Setor" location="top">
                                        
                                            <template #activator="{ props }">
                                                <v-btn
                                                    v-bind="props"
                                                    icon
                                                    size="small"
                                                    class="rounded-button"
                                                    style="background-color: #4CAF50;"
                                                    @click="novoSetorEmpresa"
                                                >
                                                    <v-icon color="white">mdi-plus</v-icon>
                                                </v-btn>                
                                            </template>
                                        
                                        </v-tooltip>

                                    </v-col>
                                    
                                </v-row>

                                <!-- Campo de busca setores empresa -->
                                <v-text-field
                                    v-model="textoBuscaSetoresEmpresa"
                                    label="Pesquisar"
                                    placeholder="Digite sua busca..."
                                    prepend-inner-icon="mdi-magnify"
                                    variant="outlined"
                                    clearable
                                    @keyup.enter="carregarListaSetoresEmpresa"
                                    @click:clear="carregarListaSetoresEmpresa"
                                    @update:modelValue="atualizaParamentrosBuscaSetoresEmpresa"
                                />

                                <!-- Lista de setoores do modal de cadastro de empresas -->
                                <v-data-table-server
                                    item-value="idSetor"
                                    v-model:options="opcoesTabelaSetoresEmpresa"
                                    :headers="headersSetoresEmpresa"
                                    :items="listaSetoresEmpresa"
                                    :loading="carregandoSetoresEmpresa"
                                    @update:options="carregarListaSetoresEmpresa"
                                    class="elevation-2 rounded-lg"
                                    :items-length="totalSetoresEmpresa"
                                    :footer-props="{
                                        'items-per-page-text': 'Itens por página'
                                    }" 
                                    :style="{ 
                                        'font-family': 'Arial, sans-serif !important', 
                                        'font-size': '12px !important' 
                                    }"                                    
                                >
                                    
                                    <template v-slot:item.funcoes="{ item }">
                    
                                        <!-- Ícone de atalho para editar produto -->
                                        <v-tooltip text="Editar Setor" location="bottom">
                                            <template #activator="{ props }">
                                                <v-icon
                                                    v-bind="props"
                                                    :color="item.ativo === 1 ? 'green' : 'red'" 
                                                    size="24" 
                                                    @click="editarSetorEmpresa(item.id)"
                                                    style="cursor: pointer; margin-right: 8px;"
                                                >
                                                mdi-pencil
                                                </v-icon>
                                            </template>
                                        </v-tooltip>
                                        
                                    </template>
                                    
                                    <!-- Coluna Externa -->
                                    <template #item.externa="{ item }">
                                        <span :class="item.externa === 1 ? 'text-green' : 'text-red'">
                                            {{ item.externa === 1 ? 'Sim' : 'Não' }}
                                        </span>
                                    </template>

                                    <!-- Coluna Almoxarifado -->
                                    <template #item.almoxarifado="{ item }">
                                        <span :class="item.almoxarifado === 1 ? 'text-green' : 'text-red'">
                                            {{ item.almoxarifado === 1 ? 'Sim' : 'Não' }}
                                        </span>
                                    </template>

                                    <!-- Coluna Condição (Ativo/Inativo) -->
                                    <template #item.manutencao="{ item }">
                                        <span :class="item.manutencao === 1 ? 'text-green' : 'text-red'">
                                            {{ item.manutencao === 1 ? 'Sim' : 'Não' }}
                                        </span>
                                    </template>

                                    <!-- Coluna Condição (Ativo/Inativo) -->
                                    <template #item.ativo="{ item }">
                                        <span :class="item.ativo === 1 ? 'text-green' : 'text-red'">
                                            {{ item.ativo === 1 ? 'Ativo' : 'Inativo' }}
                                        </span>
                                    </template>
                                    
                                </v-data-table-server>

                            </v-expansion-panel-text>

                        </v-expansion-panel>

                    </v-expansion-panels>

                    <!-- Acordeon com lista de diretório de backup da empresa -->
                    <v-expansion-panels 
                        v-model="acordeonBackupEmpresa" 
                        v-show="idEmpresaRecebido > 0"
                        id="acordeonBackupEmpresa"
                        style="margin-bottom: 16px;"
                    >

                        <v-expansion-panel>

                            <v-expansion-panel-title>
                                Backups
                                <span v-if="totalBackupsEmpresa > 0" class="text-caption ml-1">
                                    ({{ totalBackupsEmpresa }})
                                </span>
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>

                                <v-row class="mb-4" align="center" justify="end">

                                    <!-- Botão para criar novo backup -->
                                    <v-col cols="auto">
                                    
                                        <v-tooltip text="Novo Backup" location="top">
                                        
                                            <template #activator="{ props }">
                                                <v-btn
                                                    v-bind="props"
                                                    icon
                                                    size="small"
                                                    class="rounded-button"
                                                    style="background-color: #4CAF50;"
                                                    @click="novoBackup"
                                                >
                                                    <v-icon color="white">mdi-plus</v-icon>
                                                </v-btn>                
                                            </template>
                                        
                                        </v-tooltip>

                                    </v-col>

                                </v-row>

                                <!-- Campo de busca backups da empresa -->
                                <v-text-field
                                    v-model="textoBuscaBackupEmpresa"
                                    label="Pesquisar"
                                    placeholder="Digite sua busca..."
                                    prepend-inner-icon="mdi-magnify"
                                    variant="outlined"
                                    clearable
                                    @keyup.enter="carregarListaBackupsEmpresa"
                                    @click:clear="carregarListaBackupsEmpresa"
                                    @update:modelValue="onBuscaBackupsAtualizada"
                                />

                                <!-- Lista de backups do modal de cadastro de empresas -->
                                <v-data-table-server
                                    item-value="id"
                                    v-model:options="opcoesTabelaBackupsEmpresa"
                                    :headers="headersBackupsEmpresa"
                                    :items="listaBackupEmpresa"
                                    :loading="carregandoBackupEmpresa"
                                    @update:options="carregarListaBackupsEmpresa"
                                    class="elevation-2 rounded-lg"
                                    density="compact"
                                    :items-length="totalBackupsEmpresa"
                                    :footer-props="{
                                        'items-per-page-text': 'Itens por página'
                                    }" 
                                    :style="{ 
                                        'font-family': 'Arial, sans-serif !important', 
                                        'font-size': '12px !important' 
                                    }"                                   
                                >
                                    
                                    <template v-slot:item.funcoes="{ item, index }">
                    
                                        <!-- Ícone de atalho para editar chamado -->
                                        <v-tooltip text="Editar Backup" location="bottom">
                                            <template #activator="{ props }">
                                                <v-icon
                                                    v-bind="props"
                                                    :color="'green'" 
                                                    size="24" 
                                                    @click="carregaDadosBackup(item.id)"
                                                    style="cursor: pointer; margin-right: 8px;"
                                                >
                                                mdi-pencil
                                                </v-icon>
                                            </template>
                                        </v-tooltip>

                                        <!-- Ícone de atalho para excluir diretório -->
                                        <v-tooltip text="Excluir Backup" location="bottom">
                                            <template #activator="{ props }">
                                                <v-icon
                                                    v-bind="props"
                                                    color="red"
                                                    size="22"
                                                    @click="abreModalConfirmacao(index, 'backups', item.id, null)"
                                                    style="cursor: pointer;"
                                                    class="hover-icon"
                                                >
                                                    mdi-trash-can
                                                </v-icon>
                                            </template>
                                        </v-tooltip>
                                        
                                    </template>
                                    
                                </v-data-table-server>

                            </v-expansion-panel-text>

                        </v-expansion-panel>

                    </v-expansion-panels>

                    <!-- Campo contendo os arquivos anexos ao chamado -->
                    <v-row dense
                        v-show="idEmpresaRecebido > 0"
                    >

                        <v-col cols="12">

                            <v-file-input
                                v-model="mostraAnexosEmpresa"
                                multiple
                                label="Selecione os Documentos"
                                prepend-icon="mdi-paperclip"
                                @change="manipuladorArquivoEmpresa"
                                :loading="fazendoUploadArquivoEmpresa"
                                :disabled="fazendoUploadArquivoEmpresa"
                                class="ma-4"
                                :clearable=false
                            >
                                <template v-slot:selection="{ file }">

                                    <v-chip
                                    
                                        v-for="(fileObj, index) in arquivosAnexadosEmpresa"
                                        :key="fileObj.uniqueId || index"
                                        close
                                        class="ma-1"
                                        :color="fileObj.isExisting ? 'primary' : 'default'"
                                    >
                                        {{ fileObj.displayName }}

                                        <!-- Ícone para remover o arquivo -->
                                        <v-icon
                                            class="ml-2"
                                            color="red"
                                            size="18"
                                            @click.stop="abreModalConfirmacao(index, 'arquivos-upload')"
                                            style="cursor: pointer;"
                                        >
                                            mdi-close-circle
                                        </v-icon>

                                        <!-- Ícone para download, se o arquivo já existir -->
                                        <v-icon 
                                            v-if="fileObj.isExisting" 
                                            class="ml-1"
                                            color="blue"
                                            size="18"
                                            @click.stop="baixarAnexo(fileObj, 'anexos_empresa')"
                                            style="cursor: pointer;"
                                        >
                                            mdi-download
                                        </v-icon>

                                    </v-chip>
                                    
                                </template>

                            </v-file-input>

                            <!-- Barra de mensagem verde -->
                            <v-alert
                                v-model="showMessageEmpresa"
                                :type="messageType"
                                density="compact"
                                variant="tonal"
                                class="mt-2 mb-4 mx-4"
                            >
                                {{ messageText }}
                            </v-alert>
                            
                            <v-progress-linear
                                v-if="fazendoUploadArquivoEmpresa"
                                v-model="uploadProgressEmpresa"
                                color="light-blue"
                                height="10"
                                class="ma-4"
                            >
                            </v-progress-linear>

                            <v-alert
                                v-if="uploadMessageEmpresa"
                                :type="isError ? 'error' : 'success'"
                                class="ma-4"
                            >
                                {{ uploadMessageEmpresa }}
                            </v-alert>

                        </v-col>

                    </v-row>

                    <!-- Botões retornar, salvar, salvar retornar e salvar e novo do cadastro de empresas -->
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            class="ma-2"
                            style="background-color: orange; color: white;"
                            @click="funcaoRetornar()"
                            >
                            <v-icon left>mdi-chevron-left</v-icon>
                            Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2"
                            style="background-color: #2196F3; color: white;"
                            @click="validarSalvarEmpresa('salvar')"
                            >
                            <v-icon left color="white">mdi-update</v-icon>
                            Salvar
                        </v-btn>

                        <v-btn
                            class="ma-2"
                            outlined
                            style="background-color: white; border: 2px solid orange; color: orange;"
                            @click="validarSalvarEmpresa('salvar-retornar')"
                            >
                            <v-icon left color="orange">mdi-update</v-icon>
                            Salvar e Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2"
                            outlined
                            style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                            @click="validarSalvarEmpresa('salvar-novo')"
                            >
                            <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                            Salvar e Novo
                        </v-btn>

                    </v-card-actions>
                    
                </v-card>

            </v-container>

            <!-- Modal de confirmação -->
            <ModalConfirmacao
                v-model="showModal"
                title="Confirma Exclusão"
                :message="modalMessage"
                @confirm="executarRemocao"
                @cancel="cancelarRemocao"
            />

        </v-main>

    </v-app>

    <!-- Modal cadastro de colaboradores -->
    <v-dialog v-model="modalDadosColaboradorEmpresa.visible" max-width="80%" persistent>

        <!-- Card que contém os dados do chamado e só é mostrado quando existem dados na variável modalDadosChamado -->
        <v-card>
            
            <!-- Barra superior modal colaboradores -->
            <v-toolbar color="primary" dark>

                <v-toolbar-title>
                    <v-icon left>mdi-clipboard-text-outline</v-icon>
                    Colaboradores da Empresa
                </v-toolbar-title>
                
                <v-spacer></v-spacer>
                <v-btn icon @click="fecharModalColaborador">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-toolbar>

            <v-card-text>

                <!-- Formulário para editar os dados do chamado -->
                <v-form ref="formCadastroColaboradorEmpresa" v-model="validaCadastroColaborador">

                    <v-row dense>

                        <!-- Campo nome do setor -->
                        <v-col 
                            :cols="12"
                            :sm="dadosEmpresa.empresaManutencao == 1 ? 3 : 3"
                        >
                            <v-select
                                v-model="modalDadosColaboradorEmpresa.data.idSetor"
                                :items="modalDadosColaboradorEmpresa.data.listaSetores"
                                label="Setor"
                                item-title="nome"
                                item-value="id"
                                density="comfortable"
                                :rules="[rules.required]"
                                style="margin-top: 8px;"
                            />                            
                        </v-col>

                        <!-- Campo nome do colaborador -->
                        <v-col 
                            :cols="12"
                            :sm="dadosEmpresa.empresaManutencao == 1 ? 3 : 4"
                        >
                            <v-text-field 
                                label="Nome" 
                                :model-value="modalDadosColaboradorEmpresa.data.nome" 
                                @update:model-value="modalDadosColaboradorEmpresa.data.nome = $event.toUpperCase()"
                                maxlength="255"
                                :rules="[rules.required]"
                                v-uppercase
                            />                            
                        </v-col>

                        <!-- Campo login do colaborador -->
                        <v-col 
                            :cols="12"
                            :sm="dadosEmpresa.empresaManutencao == 1 ? 3 : 4"
                        >
                            <v-text-field 
                                label="Login" 
                                v-model="modalDadosColaboradorEmpresa.data.login" 
                                maxlength="255"
                                :rules="[rules.required]"
                            />                            
                        </v-col>

                        <!-- Campo sexo do colaborador -->
                        <v-col 
                            :cols="12"
                            :sm="dadosEmpresa.empresaManutencao == 1 ? 1 : 1"
                        >
                            
                            <v-select
                                v-model="modalDadosColaboradorEmpresa.data.sexo"
                                :items="[
                                    { label: 'M', value: 0 },
                                    { label: 'F', value: 1 }
                                ]"
                                item-title="label"
                                item-value="value"
                                label="Sexo"
                                :rules="[rules.required]"
                            />

                        </v-col>

                        <!-- Valor da hora -->
                        <v-col 
                            :cols="12"
                            :sm="dadosEmpresa.empresaManutencao == 1 ? 2 : 1"
                        >
                            
                            <div v-if="dadosEmpresa.empresaManutencao">
                                <v-text-field
                                    v-model="modalDadosColaboradorEmpresa.data.valorHora"
                                    label="Valor Hora"
                                    @input="formatarValorColaborador"
                                    maxlength="15"
                                    clearable
                                />
                            </div>

                        </v-col>
                        
                    </v-row>

                    <v-row>

                        <!-- Campo senha do colaborador -->
                        <v-col cols="12" sm="6">

                            <v-text-field
                                v-model="modalDadosColaboradorEmpresa.data.senha"
                                :type="mostrarSenha ? 'text' : 'password'"
                                label="Senha"
                                :append-inner-icon="mostrarSenha ? 'mdi-eye-off' : 'mdi-eye'"
                                @click:append-inner="mostrarSenha = !mostrarSenha"
                                maxlength="32"
                                clearable
                            />

                        </v-col>

                        <!-- Campo conferência de senha do colaborador -->
                        <v-col cols="12" sm="6">

                            <v-text-field
                                v-model="modalDadosColaboradorEmpresa.data.confereSenha"
                                :type="mostrarSenha ? 'text' : 'password'"
                                label="Digite Novamente a Senha"
                                :append-inner-icon="mostrarSenha ? 'mdi-eye-off' : 'mdi-eye'"
                                @click:append-inner="mostrarSenha = !mostrarSenha"
                                maxlength="32"
                                clearable
                            />

                        </v-col>

                    </v-row>

                    <v-row>

                        <!-- Campo cargo do colaborador -->
                        <v-col cols="12" sm="3">
                            <v-text-field 
                                :model-value="modalDadosColaboradorEmpresa.data.cargo" 
                                @update:model-value="modalDadosColaboradorEmpresa.data.cargo = $event.toUpperCase()"
                                maxlength="255"
                                label="Cargo" 
                                :rules="[rules.required]"
                                v-uppercase                                
                            />                            
                        </v-col>

                        <!-- Campo email do colaborador -->
                        <v-col 
                            cols="12" 
                            :md="loginStore.emissoraTelevisao === 0 ? '4' : '3'"
                        >

                            <v-text-field 
                                label="E-mail" 
                                v-model="modalDadosColaboradorEmpresa.data.email" 
                                maxlength="255"
                            />   
                                                     
                        </v-col>

                        <!-- Campo telefone do colaborador -->
                        <v-col 
                            cols="12" 
                            :md="loginStore.emissoraTelevisao === 0 ? '3' : '3'">
                            
                            <v-text-field 
                                label="Telefone" 
                                v-model="modalDadosColaboradorEmpresa.data.telefone" 
                                maxlength="255"
                                v-telefone
                            />                            
                        </v-col>

                        <!-- Campo pontuação do colaborador -->                        
                        <v-col 
                            v-if="dadosEmpresa.emissoraTelevisao === 1"
                            cols="12" sm="2"                             
                        >
                            <v-text-field 
                                v-model="modalDadosColaboradorEmpresa.data.pontuacaoInicial" 
                                @input="limitarTamanho($event, 5)"
                                maxlength="5"
                                clearable
                                label="Pontuação Inicial"
                                inputmode="numeric"                    
                            />                            
                        </v-col>

                        <v-col cols="12" sm="2">
                            
                            <v-switch
                                v-model="modalDadosColaboradorEmpresa.data.ativo"
                                :label="modalDadosColaboradorEmpresa.data.ativo ? 'Ativo' : 'Inativo'"
                                :color="modalDadosColaboradorEmpresa.data.ativo ? 'blue' : 'grey'"                                
                            />

                        </v-col>
                    
                    </v-row>

                     <v-row 
                        dense 
                        class="align-center justify-space-between"
                    >

                        <v-checkbox
                            v-model="modalDadosColaboradorEmpresa.data.administrador"
                            label="Administrador"
                            color="primary"
                            hide-details
                            density="compact"
                            @update:model-value="() => atualizarCheckbox('administrador')"
                        />
                    
                        <v-checkbox
                            v-if="dadosEmpresa.emissoraTelevisao === true" 
                            v-model="modalDadosColaboradorEmpresa.data.liberador"
                            label="Liberador"
                            color="primary"
                            hide-details
                            density="compact"
                            @update:model-value="() => atualizarCheckbox('liberador')"
                        />
                    
                        <v-checkbox
                            v-if="dadosEmpresa.emissoraTelevisao === true" 
                            v-model="modalDadosColaboradorEmpresa.data.cinegrafista"
                            label="Cinegrafista"
                            color="primary"
                            hide-details
                            density="compact"
                            @update:model-value="() => atualizarCheckbox('cinegrafista')"
                        />
                            
                        <v-checkbox
                            v-if="dadosEmpresa.emissoraTelevisao === true" 
                            v-model="modalDadosColaboradorEmpresa.data.motorista"
                            label="Motorista"
                            color="primary"
                            hide-details
                            density="compact"
                            @update:model-value="() => atualizarCheckbox('motorista')"
                        />                            
                            
                        <v-checkbox
                            v-if="dadosEmpresa.emissoraTelevisao === true" 
                            v-model="modalDadosColaboradorEmpresa.data.reporter"
                            label="Repórter"
                            color="primary"
                            hide-details
                            density="compact"
                            @update:model-value="() => atualizarCheckbox('reporter')"
                        />
                    
                        <v-checkbox
                            v-if="dadosEmpresa.emissoraTelevisao === true" 
                            v-model="modalDadosColaboradorEmpresa.data.tecnico"
                            label="Técnico"
                            color="primary"
                            hide-details
                            density="compact"
                            @update:model-value="() => atualizarCheckbox('tecnico')"
                        />
                     
                    </v-row>

                </v-form>

            </v-card-text>
            
            <v-card-actions>

                <v-spacer />
                <v-btn
                    class="ma-2"
                    style="background-color: orange; color: white;"
                    @click="fecharModalColaborador"
                    >
                    <v-icon left>mdi-chevron-left</v-icon>
                    Retornar
                </v-btn>

                <v-btn
                    class="ma-2"
                    style="background-color: #2196F3; color: white;"
                    @click="validarSalvarColaborador('salvar')"
                    >
                    <v-icon left color="white">mdi-update</v-icon>
                    Salvar
                </v-btn>

                <v-btn
                    class="ma-2"
                    outlined
                    style="background-color: white; border: 2px solid orange; color: orange;"
                    @click="validarSalvarColaborador('salvar-retornar')"
                    >
                    <v-icon left color="orange">mdi-update</v-icon>
                    Salvar e Retornar
                </v-btn>

                <v-btn
                    class="ma-2"
                    outlined
                    style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                    @click="validarSalvarColaborador('salvar-novo')"
                    >
                    <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                    Salvar e Novo
                </v-btn>
            </v-card-actions>

        </v-card>

    </v-dialog>

    <!-- Modal cadastro de colaboradores -->
    <v-dialog v-model="modalDadosProdutoEmpresa.visible" max-width="80%" persistent>

        <!-- Card que contém os dados do chamado e só é mostrado quando existem dados na variável modalDadosChamado -->
        <v-card>
            
            <!-- Barra superior modal produtos -->
            <v-toolbar color="primary" dark>

                <v-toolbar-title>
                    <v-icon left>mdi-clipboard-text-outline</v-icon>
                    Produtos da Empresa
                </v-toolbar-title>
                
                <v-spacer></v-spacer>
                <v-btn icon @click="fecharModalProdutoEmpresa">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-toolbar>

            <v-card-text>

                <!-- Formulário para editar os dados do chamado -->
                <v-form ref="formCadastroProdutoEmpresa" v-model="validaCadastroProdutoEmpresa">

                    <v-row dense>

                        <v-col cols="12" sm="11">

                            <!-- Select que mostra a lista de produtos. Seleciona o produto apontado por idProdutos -->
                            <v-select
                                v-model="modalDadosProdutoEmpresa.data.idProdutoEmpresa"
                                :items="modalDadosProdutoEmpresa.data.produtoEmpresa"
                                label="Produto"
                                item-title="title"
                                item-value="value"
                                @update:modelValue="buscarPrecoProduto"
                                clearable                                
                            ></v-select>
                        
                        </v-col>                        
                        
                        <v-col cols="12" md="1" class="d-flex align-center">
                            <v-switch
                                v-model="modalDadosProdutoEmpresa.data.ativo"
                                :label="modalDadosProdutoEmpresa.data.ativo ? 'Ativo' : 'Inativo'"
                                :color="modalDadosProdutoEmpresa.data.ativo ? 'blue' : 'white'"                                
                            />
                        </v-col>

                        <!-- Campo precoLicenca -->
                        <v-col cols="12" sm="4">
                            <v-text-field 
                                label="Preço Tabela" 
                                v-model="modalDadosProdutoEmpresa.data.precoTabela" 
                                maxlength="11"
                                :rules="[rules.required]"                                
                                placeholder="0,00"
                                type="text"
                                variant="filled"
                                @input="(e) => formatarCusto(e, 'precoTabela')"
                                @blur="calcularPrecoTotal"
                            />                            
                        </v-col>

                        <!-- Campo quantidadeLicencas -->
                        <v-col cols="12" sm="4">
                            <v-text-field 
                                label="Quantidade Licenças" 
                                v-model="modalDadosProdutoEmpresa.data.quantidadeLicencas" 
                                maxlength="4"
                                :rules="[rules.required]"
                                v-uppercase
                                @blur="calcularPrecoTotal"
                            />                            
                        </v-col>

                        <!-- Campo precoTotal -->
                        <v-col cols="12" sm="4">
                            <v-text-field 
                                label="Preço Total" 
                                v-model="modalDadosProdutoEmpresa.data.precoTotal" 
                                maxlength="13"
                                :rules="[rules.required]"
                                placeholder="0,00"
                                type="text"
                                variant="filled"
                                @input="(e) => formatarCusto(e, 'precoTotal')"
                            />                            
                        </v-col>

                    </v-row>

                </v-form>

            </v-card-text>
            
            <v-card-actions>

                <v-spacer />
                <v-btn
                    class="ma-2"
                    style="background-color: orange; color: white;"
                    @click="fecharModalProdutoEmpresa"
                    >
                    <v-icon left>mdi-chevron-left</v-icon>
                    Retornar
                </v-btn>

                <v-btn
                    class="ma-2"
                    style="background-color: #2196F3; color: white;"
                    @click="validarSalvarProdutoEmpresa('salvar')"
                    >
                    <v-icon left color="white">mdi-update</v-icon>
                    Salvar
                </v-btn>

                <v-btn
                    class="ma-2"
                    outlined
                    style="background-color: white; border: 2px solid orange; color: orange;"
                    @click="validarSalvarProdutoEmpresa('salvar-retornar')"
                    >
                    <v-icon left color="orange">mdi-update</v-icon>
                    Salvar e Retornar
                </v-btn>

                <v-btn
                    class="ma-2"
                    outlined
                    style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                    @click="validarSalvarProdutoEmpresa('salvar-novo')"
                    >
                    <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                    Salvar e Novo
                </v-btn>

            </v-card-actions>

        </v-card>

    </v-dialog>

    <!-- Modal cadastro de setores -->
    <v-dialog v-model="modalDadosSetoresEmpresa.visible" max-width="80%" persistent="">

        <v-card>

            <!-- Barra superior modal setores -->
            <v-toolbar color="primary" dark>

                <v-toolbar-title>
                    <v-icon left>mdi-clipboard-text-outline</v-icon>
                    Setores da Empresa
                </v-toolbar-title>
                
                <v-spacer></v-spacer>
                <v-btn icon @click="fecharModalSetoresEmpresa">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-toolbar>

            <v-card-text>

                <v-form ref="formCadastroSetoresEmpresa" v-model="validaCadastroSetoresEmpresa">

                    <v-row dense>

                        <!-- Campo nome do setor -->
                        <v-col cols="12" sm="12">
                            <v-text-field 
                                label="Nome Setor" 
                                :model-value="modalDadosSetoresEmpresa.data.nome"
                                @update:model-value="modalDadosSetoresEmpresa.data.nome = $event.toUpperCase()"
                                maxlength="45"
                                :rules="[rules.required]"                  
                            />                            
                        </v-col>

                    </v-row>

                    <v-row dense>

                        <v-col cols="12" sm="3"
                            v-if="loginStore.emissoraTelevisao === 1"
                        >
                            
                            <v-switch
                                v-model="modalDadosSetoresEmpresa.data.externa"
                                :label="modalDadosSetoresEmpresa.data.externa ? 'Externa' : 'Não é Externa'"
                                :color="modalDadosSetoresEmpresa.data.externa ? 'blue' : 'grey'"                                
                            />

                        </v-col>

                        <v-col cols="12" sm="3"
                                v-if="loginStore.emissoraTelevisao === 1"
                            >                            
                            <v-switch
                                v-model="modalDadosSetoresEmpresa.data.almoxarifado"
                                :label="modalDadosSetoresEmpresa.data.almoxarifado ? 'Almoxarifado' : 'Não é Almoxarifado'"
                                :color="modalDadosSetoresEmpresa.data.almoxarifado ? 'blue' : 'grey'"                                
                            />

                        </v-col>

                        <v-col cols="12" sm="3"
                            v-if="loginStore.emissoraTelevisao === 1"
                        >
                            
                            <v-switch
                                v-model="modalDadosSetoresEmpresa.data.manutencao"
                                :label="modalDadosSetoresEmpresa.data.manutencao ? 'Manutenção' : 'Não é Manutenção'"
                                :color="modalDadosSetoresEmpresa.data.manutencao ? 'blue' : 'grey'"                                
                            />

                        </v-col>

                        <v-col cols="12" sm="3">
                            
                            <v-switch
                                v-model="modalDadosSetoresEmpresa.data.ativo"
                                :label="modalDadosSetoresEmpresa.data.ativo ? 'Ativo' : 'Inativo'"
                                :color="modalDadosSetoresEmpresa.data.ativo ? 'blue' : 'grey'"                                
                            />

                        </v-col>

                    </v-row>

                </v-form>

            </v-card-text>

            <v-card-actions class="flex-wrap">

                <v-spacer />

                <v-btn
                    class="ma-2 flex-grow-1 flex-sm-grow-0"
                    style="background-color: orange; color: white;"
                    @click="fecharModalSetoresEmpresa"
                    >
                    <v-icon left>mdi-chevron-left</v-icon>
                    Retornar
                </v-btn>

                <v-btn
                    class="ma-2 flex-grow-1 flex-sm-grow-0"
                    style="background-color: #2196F3; color: white;"
                    @click="validarSalvarSetoresEmpresa('salvar')"
                    >
                    <v-icon left color="white">mdi-update</v-icon>
                    Salvar
                </v-btn>

                <v-btn
                    class="ma-2 flex-grow-1 flex-sm-grow-0"
                    outlined
                    style="background-color: white; border: 2px solid orange; color: orange;"
                    @click="validarSalvarSetoresEmpresa('salvar-retornar')"
                    >
                    <v-icon left color="orange">mdi-update</v-icon>
                    Salvar e Retornar
                </v-btn>

                <v-btn
                    class="ma-2 flex-grow-1 flex-sm-grow-0"
                    outlined
                    style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                    @click="validarSalvarSetoresEmpresa('salvar-novo')"
                    >
                    <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                    Salvar e Novo
                </v-btn>

            </v-card-actions>

        </v-card>

    </v-dialog>

    <!-- Modal Cadastro de backups -->
    <v-dialog v-model="modalDadosBackupEmpresa.visible" max-width="80%" persistent content-class="elevation-24">

        <!-- Barra superior modal backups -->
        <v-toolbar color="primary" dark>

            <v-toolbar-title>
                <v-icon left>mdi-clipboard-text-outline</v-icon>
                Backup's da Empresa
            </v-toolbar-title>
            
            <v-spacer></v-spacer>
            <v-btn icon @click="fecharModalBackupEmpresa">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <!-- Card que contém os dados do chamado e só é mostrado quando existem dados na variável modalDadosChamado -->
        <v-row>

            <v-col cols="12" md="12">
        
                <v-card 
                    class="pa-3"
                    elevation="12"
                    rounded="lg"
                >
                    <v-card-text>

                        <!-- Formulário para editar os dados do chamado -->
                        <v-form ref="formCadastroBackupsEmpresa" v-model="validaCadastroBackupEmpresa">

                            <v-row dense>

                                <!-- Campo Servidor Origem -->
                                <v-col cols="12" sm="10">
                                    <v-text-field 
                                        label="Endereço Servidor Origem" 
                                        v-model="modalDadosBackupEmpresa.data.servidor_origem" 
                                        maxlength="255"
                                        :rules="[rules.required]"
                                        placeholder="Endereço Servidor Origem"
                                        type="text"
                                        variant="filled"
                                    />                            
                                </v-col>

                                <!-- Campo Porta Servidor Origem -->
                                <v-col cols="12" sm="2">
                                    <v-text-field 
                                        label="Porta Servidor Origem" 
                                        v-model="modalDadosBackupEmpresa.data.porta_servidor_origem"
                                        maxlength="6"
                                        :rules="[rules.required]"                                
                                        placeholder="Porta Servidor Origem"
                                        type="text"
                                        variant="filled"
                                        v-numerico
                                    />                            
                                </v-col>

                            </v-row>

                            <v-row dense>

                                <!-- Campo Usuário Servidor Origem -->
                                <v-col cols="12" sm="6">
                                    <v-text-field 
                                        label="Usuário Servidor Origem" 
                                        v-model="modalDadosBackupEmpresa.data.usuario_servidor_origem" 
                                        maxlength="255"
                                        :rules="[rules.required]"                                
                                        placeholder="Usuário Servidor Origem"
                                        type="text"
                                        variant="filled"
                                        autocomplete="new-password" 
                                    />                                       
                                </v-col>

                                <!-- Campo Senha Servidor Origem-->
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        v-model="modalDadosBackupEmpresa.data.senha_servidor_origem"
                                        label="Senha Servidor Origem"
                                        prepend-inner-icon="mdi-lock-outline"
                                        :type="showPassword ? 'text' : 'password'"
                                        color="primary"
                                        :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                        @click:append-inner="showPassword = !showPassword"  
                                        autocomplete="new-password" 
                                    />
                                </v-col>

                            </v-row>

                            <v-row dense>

                                <!-- Campo Chave Privada Servidor Origem -->
                                <v-col cols="12" sm="12">
                                    <v-text-field 
                                        label="Chave Privada Servidor Origem" 
                                        v-model="modalDadosBackupEmpresa.data.chave_privada_origem" 
                                        maxlength="1024"
                                        placeholder="Chave Privada Servidor Origem"
                                        type="text"
                                        variant="filled"
                                    />                            
                                </v-col>

                            </v-row>

                            <v-row dense>

                                <!-- Campo Servidor Destino -->
                                <v-col cols="12" sm="10">
                                    <v-text-field 
                                        label="Endereço Servidor Destino" 
                                        v-model="modalDadosBackupEmpresa.data.servidor_destino" 
                                        maxlength="255"
                                        :rules="[rules.required]"                                
                                        placeholder="Endereço Servidor Destino"
                                        type="text"
                                        variant="filled"
                                    />                            
                                </v-col>

                                <!-- Campo Porta Servidor Destino -->
                                <v-col cols="12" sm="2">
                                    <v-text-field 
                                        label="Porta Servidor Destino" 
                                        v-model="modalDadosBackupEmpresa.data.porta_servidor_destino" 
                                        maxlength="255"
                                        :rules="[rules.required]"                                
                                        placeholder="Porta Servidor Destino"
                                        type="text"
                                        variant="filled"
                                        v-numerico
                                    />                            
                                </v-col>

                            </v-row>

                            <v-row dense>

                                <!-- Campo Usuário Servidor Origem -->
                                <v-col cols="12" sm="6">
                                    <v-text-field 
                                        label="Usuário Servidor Destino" 
                                        v-model="modalDadosBackupEmpresa.data.usuario_servidor_destino" 
                                        maxlength="255"
                                        :rules="[rules.required]"                                
                                        placeholder="Usuário Servidor Destino"
                                        type="text"
                                        variant="filled"
                                    />                            
                                </v-col>

                                <!-- Campo Senha Servidor Destino -->
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        v-model="modalDadosBackupEmpresa.data.senha_servidor_destino"
                                        label="Senha Servidor Destino"
                                        prepend-inner-icon="mdi-lock-outline"
                                        :type="showPassword ? 'text' : 'password'"
                                        color="primary"
                                        :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                        @click:append-inner="showPassword = !showPassword"                                
                                    />
                                </v-col>

                            </v-row>

                            <!-- Campo Chave Privada Servidor Destino -->                        
                            <v-row dense>

                                <v-col cols="12" sm="12">
                                    <v-text-field 
                                        label="Chave Privada Servidor Destino" 
                                        v-model="modalDadosBackupEmpresa.data.chave_privada_destino" 
                                        maxlength="1024"
                                        placeholder="Chave Privada Servidor Destino"
                                        type="text"
                                        variant="filled"
                                    />                            
                                </v-col>

                            </v-row>

                            <v-row v-if="modalDadosBackupEmpresa.data.id">

                                <v-col cols="12" md="12">

                                    <v-card 
                                        class="pa-4"
                                        elevation="2"
                                        rounded="lg"
                                    >
                                        <!-- Cabeçalho do Card dos diretórios do backup com Título e Botão alinhado à direita -->
                                        <v-card-title class="d-flex align-center pa-0 mb-4">

                                            <span class="text-subtitle-1 font-weight-medium">
                                                Diretórios de Backup
                                                <v-chip 
                                                    v-if="modalDadosBackupEmpresa.data.diretorios?.length > 0"
                                                    size="x-small"
                                                    color="primary"
                                                    class="ml-2"
                                                >
                                                    {{ modalDadosBackupEmpresa.data.diretorios.length }}
                                                </v-chip>
                                            </span>
                                            
                                            <v-spacer />
                                            
                                            <!-- ✅ Botão alinhado à direita -->
                                            <v-btn
                                                icon
                                                size="small"
                                                class="rounded-button"
                                                style="background-color: #4CAF50;"
                                                @click="novoDiretorioBackup"
                                            >
                                                <v-icon color="white">mdi-plus</v-icon>
                                            </v-btn>
                                        </v-card-title>

                                        <v-divider class="mb-4" />

                                        <div 
                                            style="
                                                max-height: 250px; 
                                                overflow-y: auto; 
                                                overflow-x: hidden;
                                                border-radius: 8px;
                                            "
                                            class="table-scroll-wrapper"
                                        >

                                            <!-- Lista de diretórios do backup -->
                                            <v-data-table-server
                                                item-value="id"
                                                v-model:options="opcoesTabelaDiretoriosBackups"
                                                :headers="headersDiretoriosBackupsEmpresa"
                                                :items="modalDadosBackupEmpresa.data.diretorios || []"
                                                :loading="carregandoDiretoriosBackupEmpresa"
                                                class="elevation-1 rounded-lg"
                                                density="compact"
                                                :items-length="totalDiretoriosBackupsEmpresa"
                                                :footer-props="{
                                                    'items-per-page-text': 'Itens por página'
                                                }"
                                                :style="{ 
                                                    'font-family': 'Arial, sans-serif !important', 
                                                    'font-size': '12px !important' 
                                                }"
                                                :items-per-page="-1"
                                            >
                                                <template v-slot:item.funcoes="{ item, index }">

                                                    <!-- Ícone de atalho para editar diretório -->
                                                    <v-tooltip text="Editar Diretório" location="bottom">
                                                        <template #activator="{ props }">
                                                            <v-icon
                                                                v-bind="props"
                                                                color="green"
                                                                size="22"
                                                                @click="editarDiretorioBackupEmpresa(index)"
                                                                style="cursor: pointer; margin-right: 8px;"
                                                                class="hover-icon"
                                                            >
                                                                mdi-pencil
                                                            </v-icon>
                                                        </template>
                                                    </v-tooltip>

                                                    <!-- Ícone de atalho para excluir diretório -->
                                                    <v-tooltip text="Excluir Diretório" location="bottom">
                                                        <template #activator="{ props }">
                                                            <v-icon
                                                                v-bind="props"
                                                                color="red"
                                                                size="22"
                                                                @click="abreModalConfirmacao(index, 'diretorios-backups', null, item.id)"
                                                                style="cursor: pointer;"
                                                                class="hover-icon"
                                                            >
                                                                mdi-trash-can
                                                            </v-icon>
                                                        </template>
                                                    </v-tooltip>
                                                </template>

                                                <!-- Mensagem quando não há diretórios -->
                                                <template #no-data>
                                                    <div class="text-center pa-4">
                                                        <v-icon color="grey-lighten-1" size="40" class="mb-2">mdi-folder-open</v-icon>
                                                        <p class="text-caption text-grey">
                                                            Nenhum diretório configurado.
                                                            <br>
                                                            Clique no botão <strong>"+"</strong> para adicionar.
                                                        </p>
                                                    </div>
                                                </template>

                                            </v-data-table-server>

                                        </div>

                                    </v-card>
                                </v-col>
                            </v-row>

                            <!-- Coluna Condição (Ativo/Inativo) -->
                            <v-row>

                                <v-col cols="12" md="3" class="d-flex align-center">
                                    <v-switch
                                        :label="modalDadosBackupEmpresa.data.ativo ? 'Ativo' : 'Inativo'"
                                        :color="modalDadosBackupEmpresa.data.ativo ? 'blue' : 'white'"
                                        v-model="modalDadosBackupEmpresa.data.ativo"
                                    />
                                </v-col>
                            </v-row>

                        </v-form>

                    </v-card-text>
                    
                    <v-card-actions>

                        <v-spacer />
                        <v-btn
                            class="ma-2"
                            style="background-color: orange; color: white;"
                            @click="fecharModalBackupEmpresa"
                            >
                            <v-icon left>mdi-chevron-left</v-icon>
                            Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2"
                            style="background-color: #2196F3; color: white;"
                            @click="validarSalvarBackupsEmpresa('salvar')"
                            >
                            <v-icon left color="white">mdi-update</v-icon>
                            Salvar
                        </v-btn>

                        <v-btn
                            class="ma-2"
                            outlined
                            style="background-color: white; border: 2px solid orange; color: orange;"
                            @click="validarSalvarBackupsEmpresa('salvar-retornar')"
                            >
                            <v-icon left color="orange">mdi-update</v-icon>
                            Salvar e Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2"
                            outlined
                            style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                            @click="validarSalvarBackupsEmpresa('salvar-novo')"
                            >
                            <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                            Salvar e Novo
                        </v-btn>

                    </v-card-actions>

                </v-card>

            </v-col>

        </v-row>

    </v-dialog>

    <!-- Modal Cadastro de diretórios -->
    <v-dialog v-model="modalDiretoriosBackup.visible" max-width="80%" persistent content-class="elevation-24">

        <!-- Card que contém os dados do chamado e só é mostrado quando existem dados na variável modalDadosChamado -->
        <v-card>
            
            <!-- Barra superior modal diretórios backup -->
            <v-toolbar color="primary" dark>

                <v-toolbar-title>
                    <v-icon left>mdi-clipboard-text-outline</v-icon>
                    Diretórios Backup da Empresa
                </v-toolbar-title>
                
                <v-spacer></v-spacer>
                <v-btn icon @click="fecharModalDiretoriosBackupEmpresa">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-toolbar>

            <v-card-text>

                <!-- Formulário para editar os dados do chamado -->
                <v-form ref="formCadastroDiretoriosBackupsEmpresa" v-model="validaDiretoriosBackupEmpresa">

                    <v-row dense>

                        <!-- Campo Servidor Origem -->
                        <v-col cols="12" sm="5">
                            <v-text-field 
                                ref="inputDiretorioOrigem"
                                label="Diretório Origem" 
                                v-model="modalDiretoriosBackup.data.diretorio_origem" 
                                maxlength="1024"
                                :rules="[rules.required]"
                                placeholder="Diretório Origem"
                                type="text"
                                variant="filled"
                            />                            
                        </v-col>

                        <!-- Campo Porta Servidor Origem -->
                        <v-col cols="12" sm="5">
                            <v-text-field 
                                ref="inputDiretorioDestino"
                                label="Diretório Destino" 
                                v-model="modalDiretoriosBackup.data.diretorio_destino"
                                maxlength="1024"
                                :rules="[rules.required]"                                
                                placeholder="Diretório Destino"
                                type="text"
                                variant="filled"
                            />                            
                        </v-col>

                        <v-col cols="12" sm="2">
                            <v-text-field 
                                label="Tempo Permanência em Dias" 
                                v-model="modalDiretoriosBackup.data.tempo_permanencia"
                                maxlength="4"
                                :rules="[rules.required]"                                
                                placeholder="Tempo Permanência"
                                type="text"
                                variant="filled"
                                v-numerico
                            />                            
                        </v-col>
                        
                    </v-row>
                    
                </v-form>

            </v-card-text>
            
            <v-card-actions>

                <v-spacer />
                <v-btn
                    class="ma-2"
                    style="background-color: orange; color: white;"
                    @click="fecharModalDiretoriosBackupEmpresa"
                    >
                    <v-icon left>mdi-chevron-left</v-icon>
                    Retornar
                </v-btn>

                <v-btn
                    class="ma-2"
                    style="background-color: #2196F3; color: white;"
                    @click="validarSalvarDiretoriosBackupsEmpresa('salvar')"
                    >
                    <v-icon left color="white">mdi-update</v-icon>
                    Salvar
                </v-btn>

                <v-btn
                    class="ma-2"
                    outlined
                    style="background-color: white; border: 2px solid orange; color: orange;"
                    @click="validarSalvarDiretoriosBackupsEmpresa('salvar-retornar')"
                    >
                    <v-icon left color="orange">mdi-update</v-icon>
                    Salvar e Retornar
                </v-btn>

                <v-btn
                    class="ma-2"
                    outlined
                    style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                    @click="validarSalvarDiretoriosBackupsEmpresa('salvar-novo')"
                    >
                    <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                    Salvar e Novo
                </v-btn>

            </v-card-actions>

        </v-card>

     </v-dialog>

</template>

<script setup>

    /* DEPENDENCIAS E VARIAVEIS COMUNS */
    
    // Importa as funcionalidades do Vue
    import { ref, watch, onMounted, onBeforeUnmount, computed, nextTick } from 'vue'

    // Importa axios para chamadas API
    import axios from 'axios'

    // Importa o editor de texto rico Quill
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    // Importa o event bus
    import { emitter } from '../utils/eventBus'

    // Importa o componente do formulário de erros
    import { useErroStore } from '@/stores/erroStore'

    // Importa o componente do Snackbar
    import { useSnackbarStore } from '@/stores/snackbar'

    // Retorna um objeto com informações internas sobre o componente que está sendo executado no momento    
    import { getCurrentInstance } from 'vue'

    // Importa o componente do formulário de login
    import { useLoginStore } from '@/stores/loginStore'

    // Importa useRouter para acessar parâmetros de rota
    import { useRouter } from 'vue-router'

    // Importa useRoute para acessar parâmetros de rota
    import { useRoute } from 'vue-router'

    // Importando como módulo padrão (se for export default)
    import { useSenhaStore } from '../stores/senhaStore';

    // Importa formulário de confirmação de operação
    import ModalConfirmacao from '@/components/ModalConfirmacao.vue'

    // Importa o composable para upload de arquivos
    import { useUploadArquivos } from '@/composables/useUploadArquivos';

    // Desestrutura as funções do composable de upload de arquivos para facilitar o uso
    const { uploadArquivos, fazendoUpload } = useUploadArquivos();
    
    // Importa composable de download de arquivos
    import { useDownloadArquivo } from '@/composables/useDownloadArquivo';
    
    // Importa o canal de comunicação entre componentes
    import { channel } from '@/utils/channel'

    const uploadProgressEmpresa = ref(0);
    const isError = ref(false);
    
    // Importa o composable
    const { downloadArquivo } = useDownloadArquivo();
    
    // Estados locais para controle individual
    const baixandoArquivoId = ref(null);
    const progressoDownloadLocal = ref(0);
    
    // Carrega o endereço das ap
    const API_BASE_URL = import.meta.env.VITE_API_URL;

    // Inicializa o store
    const senhaStore = useSenhaStore();

    // Importa a store de erros
    const erroStore = useErroStore()

    // Importa a store do snackbar
    const snackbar = useSnackbarStore()

    // Permite acessar rotinas globais
    const { proxy } = getCurrentInstance()

    // Importa a store de chamados
    const loginStore = useLoginStore()

    // Acessa o ID da empresa via query param
    const router = useRouter();

    // Acessa o ID da empresa via query param
    const route = useRoute(); 

    
    /* VARIAVEIS DO FORMULÁRIO */
    
    // Variável para armazenar o ID da empresa (0 para nova empresa)
    const idEmpresaRecebido = ref(0);
    
    // Define variável para armazenar listas de ramos de atividade e status de crédito
    const listaRamosAtividade = ref([])
    const listaStatusCredito = ref([])
        
    // Define a variável para mostrar ou esconder a senha
    const mostrarSenha = ref(false)
    
    // Validação do formulário de empresa
    const validaCadastroEmpresa = ref(false)

    // Validação do fomrulário colaborador
    const validaCadastroColaborador = ref(false)

    // Validação do fomrulário colaborador
    const validaCadastroProdutoEmpresa = ref(false)
    
    // Validação do formulário setores empresa
    const validaCadastroSetoresEmpresa = ref(false)

    // Validação do formulário backups da empresa
    const validaCadastroBackupEmpresa = ref(false)

    // Validação do formulário de diretorios dos backups da empresa
    const validaDiretoriosBackupEmpresa = ref(false)
    
    // Referência do formulário de cadastro de empresa
    const formCadastroEmpresa = ref(null)

    // Referência do formulário de cadastro de colaborador
    const formCadastroColaboradorEmpresa = ref(null)

    // Referência do formulário de cadastro de colaborador
    const formCadastroProdutoEmpresa = ref(null)

    // Referência do formulário de cadastro de setores
    const formCadastroSetoresEmpresa = ref(null)

    // Referência do formulário de cadastro de backups
    const formCadastroBackupsEmpresa = ref(null)

    const inputDiretorioOrigem = ref(null)
    const inputDiretorioDestino = ref(null)

    // Referencia do formulário de cadastro de diretorios dos backups
    const formCadastroDiretoriosBackupsEmpresa = ref(null)

    // Cria uma referencia para enviar o foco ao campo cnpj
    const focoCNPJ = ref(null)

    // Cria uma referencia para enviar o foco ao campo número
    const focoNumero = ref(null)
    
    const mostraAnexosEmpresa = ref([]);        // Arquivos mostrados no input do chamado
    const fazendoUploadArquivoEmpresa = ref(false);    // Indica se o upload dos arquivos do chamado está em andamento
    const arquivosAnexadosEmpresa = ref([]);    // Todos os arquivos (novos + existentes)
    const showMessageEmpresa = ref(false);      // Controla a exibição de mensagens no modal de chamados
    const uploadMessageEmpresa = ref('');     // Controla o tipo da mensagem (success, error, warning) no modal de chamados
    const messageType = ref('success');
    const messageText = ref('');

    // Dados da empresa
    const dadosEmpresa = ref({
        nomeFantasia: '',
        razaoSocial: '',
        apelido: '',
        custoHora: 'R$ 0,00',
        cnpj: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
        idRamoAtividade: [],
        idStatusCredito: [],
        urlSite: '',
        emailPrincipal: '',
        fonePrincipal: '',
        pais: '',        
        cep: '',
        uf: '',
        cidade: '',
        bairro: '',
        logradouro: '',
        numero: '',
        complemento: '',
        empresaManutencao: false,
        emissoraTelevisao: false,
        arquivosAnexosEmpresa: [],
        ativo: true
    })
    
    // Dados do modal dos colaboradores da empresa 
    const modalDadosColaboradorEmpresa = ref({
        visible: false,
        data:{
            id: 0,
            idEmpresa: idEmpresaRecebido.value,
            listaSetores: [],
            idSetor: null,    
            nome: '',
            login: '',
            senha: '',
            confereSenha: '',
            cargo: '',  
            sexo: '',
            email: '',
            telefone: '',
            pontuacaoInicial: '',
            valorHora: 'R$ 0,00',
            administrador: false,
            liberador: false,
            cinegrafista: false,
            motorista: false,
            reporter: false,
            tecnico: false,
            ativo: true
        }
    })

    // Dados do modal dos produtos da empresa 
    const modalDadosProdutoEmpresa = ref({
        visible: false,
        data:{
            id: 0,
            idEmpresa: idEmpresaRecebido.value,
            idProdutoEmpresa: [],
            produtoEmpresa: [],
            precoTabela: '',
            quantidadeLicencas: '',
            precoTotal: '',
            ativo: true
        }
    })

    // Dados do modal de cadastro de setores da empresa
    const modalDadosSetoresEmpresa = ref({
        visible: false,
        data: {
            id: 0,
            idEmpresa: idEmpresaRecebido.value,
            nome: '',
            externa: false,
            almoxarifado: false,
            manutencao: false,
            ativo: true
        }
    })

    // Dados do modal de cadastro de empresas
    const modalDadosBackupEmpresa = ref({
        visible: false,
        data: {
            id: 0,
            idEmpresa: idEmpresaRecebido.value,
            servidor_origem: '',
            porta_servidor_origem: '',
            usuario_servidor_origem: '',
            senha_servidor_origem: '',
            chave_privada_origem: '',  
            servidor_destino: '',
            porta_servidor_destino: '',
            usuario_servidor_destino: '',
            senha_servidor_destino: '',
            chave_privada_destino: '',
            ativo: true,
            diretorios: []
        }
    })

    // Dados do modal de cadastro de diretorios
    const modalDiretoriosBackup = ref({
        visible: false,
        data: {
            id: 0,
            diretorio_origem: '',
            diretorio_destino: '',
            tempo_permanencia: 3
        }
    })

    // Lista de todas as funções
    const funcoes = ['liberador', 'cinegrafista', 'motorista', 'reporter', 'tecnico']

    // Define arrays e variáveis para a tabela de colaboradores
    const listaColaboradores = ref([])
    const totalColaboradores = ref(0)
    const carregandoColaboradores = ref(false)
    const textoBuscaColaboradorEmpresa = ref('')
    const acordeonColaboradores = ref([])
    
    const listaProdutosEmpresa = ref([])    
    const carregandoProdutosEmpresa = ref(false)
    const textoBuscaProdutosEmpresa = ref('')
    const acordeonProdutosEmpresa = ref([])
    const totalProdutosEmpresa = ref(0)
    
    const listaSetoresEmpresa = ref([])    
    const carregandoSetoresEmpresa = ref(false)
    const textoBuscaSetoresEmpresa = ref('')
    const acordeonSetoresEmpresa = ref([])
    const totalSetoresEmpresa = ref(0)
    
    const listaBackupEmpresa = ref([])    
    const carregandoBackupEmpresa = ref(false)
    const textoBuscaBackupEmpresa = ref('')
    const acordeonBackupEmpresa = ref([])
    const totalBackupsEmpresa = ref(0)

    const carregandoDiretoriosBackupEmpresa = ref(false)
    const totalDiretoriosBackupsEmpresa = ref(0)
    
    // Estado local para o modo da barra lateral
    const modoBarraLateral = ref(false)
    
    // Controla a visibilidade do modal
    const showModal = ref(false)       
    
    // Mensagem do modal
    const modalMessage = ref('')        

    const showPassword = ref(false)

    // Dados pendentes para remoção
    const pendingData = ref({           
        index: null,
        arquivo: null,
        tipo: null,
        origem: null,
        idBackup: null,
        idDiretorioBackup: null
    })

    // Opções buscar colaboradores
    const opcoesTabelaColaboradoresEmpresa = ref({
        page: 1,
        itemsPerPage: 10,
        sortBy: [{ key: 'nome', order: 'asc' }]
    })

    // Opções buscar produtos empresa
    const opcoesTabelaProdutosEmpresa = ref({
        page: 1,
        itemsPerPage: 10,
        sortBy: [{ key: 'nome', order: 'asc' }]
    })

    // Opções buscar setores empresa
    const opcoesTabelaSetoresEmpresa = ref({
        page: 1,
        itemsPerPage: 10,
        sortBy: [{ key: 'nome', order: 'asc' }]
    })

    // Opções buscar backups
    const opcoesTabelaBackupsEmpresa = ref({
        page: 1,
        itemsPerPage: 10,
        sortBy: [{ key: 'id', order: 'asc' }]
    })

    // Opções buscar backups
    const opcoesTabelaDiretoriosBackups = ref({
        page: 1,
        itemsPerPage: 10,
        sortBy: [{ key: 'id', order: 'asc' }]
    })

    // Define os headers da tabela de colaboradores
    const headersColaboradores = [
        { title: 'Editar', value: 'funcoes', sortable: false },
        { title: 'Código', key: 'id', sortable: true },
        { title: 'Nome', key: 'nome', sortable: true },
        { title: 'Login', key: 'login', sortable: true },
        { title: 'Setor', key: 'setor', sortable: true },
        { title: 'Cargo', key: 'cargo', sortable: true },
        { title: 'Email', key: 'email', sortable: true },
        { title: 'Fone', key: 'whatsapp', sortable: true },
        { title: 'Condição', value: 'ativo', sortable: true}
    ]

    // Define os headers da tabela de produtos da empresa
    const headersProdutosEmpresa = [
        { title: 'Editar', value: 'funcoes', sortable: false },
        { title: 'Código', key: 'id', sortable: true },
        { title: 'Produto', key: 'nome', sortable: true },
        { title: 'Preço Tabela', key: 'precoTabela', sortable: true },
        { title: 'Licenças', key: 'quantidadeLicencas', sortable: true },
        { title: 'Preço Total', key: 'precoTotal', sortable: true },
        { title: 'Condição', value: 'ativo', sortable: true}
    ]

    // Define os headers base
    const headersBase = [
        { title: 'Editar', value: 'funcoes', sortable: false },
        { title: 'Código', key: 'id', sortable: true },
        { title: 'Setor', key: 'nome', sortable: true },
        { title: 'Condição', value: 'ativo', sortable: true}
    ]

    // Headers condicionais
    const headersCondicionais = [
        { title: 'Externa', key: 'externa', sortable: true },
        { title: 'Almoxarifado', key: 'almoxarifado', sortable: true },
        { title: 'Manutenção', key: 'manutencao', sortable: true }
    ]

    // Define os headers da tabela de backups
    const headersBackupsEmpresa = [
        { title: 'Editar', value: 'funcoes', sortable: false },
        { title: 'Código', key: 'id', sortable: true },
        { title: 'Origem', key: 'servidor_origem', sortable: true },
        { title: 'Destino', key: 'servidor_destino', sortable: true }
    ]
    
    // Define os headers da tabela de diretorios dos backups
    const headersDiretoriosBackupsEmpresa = [
        { title: 'Editar', value: 'funcoes', sortable: false },
        { title: 'Código', key: 'id', sortable: true },
        { title: 'Origem', key: 'diretorio_origem', sortable: true },
        { title: 'Destino', key: 'diretorio_destino', sortable: true },
        { title: 'Permanencia', key: 'tempo_permanencia', sortable: true }
    ]

    // Computed property que retorna os headers baseados na condição
    const headersSetoresEmpresa = computed(() => {

        if (loginStore.emissoraTelevisao === 1) {

            // Insere os headers condicionais antes do header 'Condição'
            const indexCondicao = headersBase.findIndex(h => h.value === 'ativo' || h.key === 'ativo')
            return [
                ...headersBase.slice(0, indexCondicao),
                ...headersCondicionais,
                ...headersBase.slice(indexCondicao)
            ]
        }
        return headersBase
    })

    // Esta rotina é chamada pelo botão para cadastrar um novo colaborador na empresa
    const novoColaborador = async () => {
        
        // Define os dados iniciais do novo colaborador
        modalDadosColaboradorEmpresa.value = {
            visible: true,
            modo: 'novo',
            data: {
                id: 0,
                idEmpresa: idEmpresaRecebido.value,
                listaSetores: [],
                idSetor: null,    
                nome: '',
                login: '',
                senha: '',
                confereSenha: '',
                cargo: '',  
                sexo: '',
                email: '',
                telefone: '',
                pontuacaoInicial: '',
                valorHora: 'R$ 0,00',
                cinegrafista: false,
                tecnico: false,
                motorista: false,
                administrador: false,
                liberador: false,
                reporter: false,
                ativo: true
            }
        }; 
    }

    // Esta rotina é chamada quando o botão novo do acordeon é pressionado
    const novoBackup = async () => {
        
        // Limpa dados do formulário
        limpaDadosBackup()

        // Torna formulário visível
        modalDadosBackupEmpresa.value.visible = true
    }

    // Função para abrir modal de cadastro dos diretórios do backup
    const novoDiretorioBackup = async () => {

        modalDiretoriosBackup.value = {
            visible: true,
            modo: 'novo',
            data: {
                id: 0,
                idBackup: modalDadosBackupEmpresa.value.data.idBackup,
                diretorio_origem: '',
                diretorio_destino: '/home/storage2/1/a8/c0/suita2',
                tempo_permanencia: 3
            }
        }
    }

    // Regras de validação
    const rules = {
        required: v => v !== null && v !== undefined && v !== '' || 'Campo obrigatório',
        cnpj: v => /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(v) || 'CNPJ inválido'
    }

    // Função para atualizar o v-model com os arquivos atuais do chamado
    const manipuladorArquivoEmpresa = (event) => {

        // Verifica se o evento contém arquivos, sai da função se não houver
        const arquivoEntrada = event.target.files;

        if (!arquivoEntrada || arquivoEntrada.length === 0) return;

        // Converte lista de arquivos para array e filtra arquivos já selecionados
        const novoArquivo = Array.from(arquivoEntrada).filter(arquivo => {

                // Verifica se o arquivo NÃO está já na lista arquivosAnexadosEmpresa
                return !arquivosAnexadosEmpresa.value.some(
                    existingFile => 
                        existingFile.name === arquivo.name && 
                        existingFile.size === arquivo.size
                );
            
        }).map(arquivo => ({
                
            name: arquivo.name,
            size: arquivo.size,
            type: arquivo.type || 'application/octet-stream',
            lastModified: arquivo.lastModified || Date.now(),
            raw: arquivo,       // Mantém a referência ao File original
            uniqueId: null,     // Será preenchido após upload
            isExisting: false,
            displayName: `${arquivo.name} (${formatFileSize(arquivo.size)})`,
            serverName: null    // Será preenchido após upload

        }));

        // Atualiza a lista de arquivos mostrados
        if (novoArquivo.length > 0) {

            // Salva o novo arquivo na lista de todos os anexos
            arquivosAnexadosEmpresa.value = [...arquivosAnexadosEmpresa.value, ...novoArquivo];
            
            // Atualiza o displayFiles para mostrar os novos arquivos
            snackbar.trigger(`${novoArquivo.length} Novo(s) Arquivo(s) Adicionado(s)`, 'success');

        } else {
            
            // Todos os arquivos selecionados já estão na lista
            snackbar.trigger('Arquivo Já Está Na Seleção', 'warning');
        }

        event.target.value = '';
    };

    // Formata o tamanho do arquivo
    const formatFileSize = (bytes) => {
        if (!bytes || isNaN(bytes)) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };
    
    // Rotina para download do arquivo anexo
    const baixarAnexo = async (fileObj, tabela) => {

        // Verifica se este arquivo específico já está baixando
        if (baixandoArquivoId.value === fileObj.uniqueId) return;
        
        // Marca apenas este arquivo como baixando
        baixandoArquivoId.value = fileObj.uniqueId;
        progressoDownloadLocal.value = 0;
        
        try {
            await downloadArquivo(fileObj, tabela, {

                showProgress: true,
                onProgress: (percentual) => {
                    // Atualiza o progresso APENAS deste arquivo
                    progressoDownloadLocal.value = percentual;
                }
            });
            
        } finally {
            baixandoArquivoId.value = null;
            progressoDownloadLocal.value = 0;
        }
    };
    
    // Salva o id da empresa
    idEmpresaRecebido.value = Number(route.query.idEmpresa) || 0;

    // Busca o modo da barra lateral vindo da lista
    modoBarraLateral.value = route.query.modoBarraLateral    
    
    // Esta rotina é chamada pelo botão para cadastrar um novo produto na empresa
    async function novoProdutoEmpresa(){

        // Limpa dados do formulário
        limpaModalDadosProdutoEmpresa()
        
        try{

            // Carrega todos produtos
            const { data: dataProdutos } = await axios.get(`${API_BASE_URL}/administracao/carregaListaProdutos`, {
                params: {
                    busca: ''
                },
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Garante que temos um array válido de produtos
            const produtos = Array.isArray(dataProdutos.data) 
                ? dataProdutos.data 
                : dataProdutos.data || []

            // Filtra produtos ativos e depois mapeia
            modalDadosProdutoEmpresa.value.data.produtoEmpresa = produtos
                .filter(produto => produto.ativo === 1)
                .map(produto => ({
                    value: produto.idProduto,
                    title: produto.nome,
                    precoTabela: produto.precoTabela
                })
            )
           
            modalDadosProdutoEmpresa.value.visible = true

        } catch(erro){
            erroStore.exibirErro(erro)
        }        
    }

    // Esta rotina é chamada pelo botão para cadastrar um novo setor na empresa
    async function novoSetorEmpresa(){

        // Limpa campos do formulário
        limpaDadosModalSetoresEmpresa()

        // Torna visível o modal de setores
        modalDadosSetoresEmpresa.value.visible = true
    }

    // Calcula preço toda dos produtos
    const calcularPrecoTotal = () => {
        
        // Remove R$, espaços, e formata para número
        const precoString = modalDadosProdutoEmpresa.value.data.precoTabela
            ?.toString()
            .replace(/R\$/g, '')         // Remove "R$"
            .replace(/\s/g, '')          // Remove espaços
            .trim();                     // Remove espaços no início/fim

        const precoLicencaCalculo = parseFloat(
            precoString
                .replace(/\./g, '')      // Remove pontos (separadores de milhar)
                .replace(',', '.')       // Substitui vírgula por ponto (decimal)
        ) || 0;
        
        // Busca quantidade de produtos
        const quantidade = parseInt(modalDadosProdutoEmpresa.value.data.quantidadeLicencas) || 0;
        
        // Multiplica o preço de tabela pela quantidade
        const precoTotal = precoLicencaCalculo * quantidade;
        
        // Formata como moeda brasileira
        const formatador = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        
        // Mostra o valor calculado no campo preço total
        modalDadosProdutoEmpresa.value.data.precoTotal = formatador.format(precoTotal);
    }

    // Função para carregar os colaboradores da empresa
    const carregarListaColaboradoresEmpresa = async () => {

        // Extrai parâmetros de forma segura e correta
        const opcoes = opcoesTabelaColaboradoresEmpresa.value

        // Ordenação - forma correta para Vuetify 3
        let ordenacaoPor = 'nome'
        let direcaoOrdenacao = 'asc'

        if (opcoes.sortBy && opcoes.sortBy.length > 0) {
            ordenacaoPor = opcoes.sortBy[0].key
            direcaoOrdenacao = opcoes.sortBy[0].order
        }
        
        // Paginação
        const paginaAtual = opcoes.page || 1
        const itensPorPagina = opcoes.itemsPerPage || 10

        // Limpa a lista de colaboradores
        listaColaboradores.value = []
        totalColaboradores.value = 0

        // Limpa a lista de colaboradores
        listaColaboradores.value = []

        // Reseta o total de colaboradores
        totalColaboradores.value = 0

        try {

            // Verifica se já está em processo de carregamento
            if (carregandoColaboradores.value == false){

                // Liga indicação de carga dos colaboradores
                carregandoColaboradores.value = true
        
                // Chama a API para buscar os colaboradores da empresa
                const response = await axios.get(`${API_BASE_URL}/administracao/carregaListaColaboradores/${idEmpresaRecebido.value}`, { 
                    params:{
                        textoBuscaColaboradorEmpresa: textoBuscaColaboradorEmpresa.value,
                        ordenacaoPor: ordenacaoPor || 'nome',  
                        direcaoOrdenacao: direcaoOrdenacao || 'asc',
                        paginaAtual: paginaAtual,
                        itensPorPagina: itensPorPagina
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Atualiza os dados dos colaboradores e o total
                listaColaboradores.value = response.data.data

                // Salva total de 
                totalColaboradores.value = response.data.total

                // Desliga indicação de carga dos colaboradores
                carregandoColaboradores.value = false        
            }

        } catch (erro) {

            // Desliga indicação de carga dos colaboradores
            carregandoColaboradores.value = false  

            // Usa a store de erros para exibir o erro
            erroStore.exibirErro(erro)

        } finally {
            carregandoColaboradores.value = false
        }
    }

    // Função para carregar os colaboradores da empresa
    const carregarListaProdutosEmpresa = async () => {
        
        // Extrai parâmetros de forma segura e correta
        const opcoes = opcoesTabelaProdutosEmpresa.value

        // Ordenação - forma correta para Vuetify 3
        let ordenacaoPor = 'nome'
        let direcaoOrdenacao = 'asc'

        if (opcoes.sortBy && opcoes.sortBy.length > 0) {
            ordenacaoPor = opcoes.sortBy[0].key
            direcaoOrdenacao = opcoes.sortBy[0].order
        }
        
        // Paginação
        const paginaAtual = opcoes.page || 1
        const itensPorPagina = opcoes.itemsPerPage || 10

        // Limpa a lista de colaboradores
        listaProdutosEmpresa.value = []

        // Reseta o total de colaboradores
        totalProdutosEmpresa.value = 0

        try {

            // Verifica se já está carregando produtos da empresa
            if (carregandoProdutosEmpresa.value == false){
           
                // Sinaliza carga dos produtos da empresa
                carregandoProdutosEmpresa.value = true

                // Chama a API para buscar os colaboradores da empresa
                const response = await axios.get(`${API_BASE_URL}/administracao/carregaListaProdutosEmpresa/${idEmpresaRecebido.value}`, { 
                    params:{
                        textoBuscaProdutosEmpresa: textoBuscaProdutosEmpresa.value,
                        ordenacaoPor: ordenacaoPor || 'nome',  
                        direcaoOrdenacao: direcaoOrdenacao || 'asc',
                        paginaAtual: paginaAtual,
                        itensPorPagina: itensPorPagina
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Formata os campos de valor monetário para padrão brasileiro
                const listaFormatada = response.data.data.map(item => ({
                    ...item,
                    precoTabela: proxy.$formatarValorParaReal(item.precoTabela),
                    precoTotal: proxy.$formatarValorParaReal(item.precoTotal)
                }))

                // Agora atribui à sua lista reativa
                listaProdutosEmpresa.value = listaFormatada

                // Salva total de registros para mostrar na tabela
                totalProdutosEmpresa.value = response.data.total

                // Sinaliza que os produtos da empresa foram carregados
                carregandoProdutosEmpresa.value = false
            }

        } catch (erro) {

            // Sinaliza que os produtos da empresa foram carregados
            carregandoProdutosEmpresa.value = false

            // Usa a store de erros para exibir o erro
            erroStore.exibirErro(erro)

        } finally {
            carregandoProdutosEmpresa.value = false
        }
    }

    // Função para carregar os setores da empresa
    const carregarListaSetoresEmpresa = async () => {
        
        // Extrai parâmetros de forma segura e correta
        const opcoes = opcoesTabelaSetoresEmpresa.value

        // Ordenação - forma correta para Vuetify 3
        let ordenacaoPor = 'nome'
        let direcaoOrdenacao = 'asc'

        if (opcoes.sortBy && opcoes.sortBy.length > 0) {
            ordenacaoPor = opcoes.sortBy[0].key
            direcaoOrdenacao = opcoes.sortBy[0].order
        }
        
        // Paginação
        const paginaAtual = opcoes.page || 1
        const itensPorPagina = opcoes.itemsPerPage || 10

        // Limpa a lista de colaboradores
        listaSetoresEmpresa.value = []

        // Reseta o total de colaboradores
        totalSetoresEmpresa.value = 0

        try {

            // Verifica se já está carregando produtos da empresa
            if (carregandoSetoresEmpresa.value == false){
           
                // Sinaliza carga dos produtos da empresa
                carregandoSetoresEmpresa.value = true

                if (loginStore.emissoraTelevisao === 0) {
                 
                    // Chama a API para buscar os colaboradores da empresa
                    var response = await axios.get(`${API_BASE_URL}/administracao/carregaListaDepartamentos`, { 
                        params:{
                            textoBuscaSetoresEmpresa: textoBuscaSetoresEmpresa.value,
                            ordenacaoPor: ordenacaoPor || 'nome',  
                            direcaoOrdenacao: direcaoOrdenacao || 'asc',
                            paginaAtual: paginaAtual,
                            itensPorPagina: itensPorPagina
                        },
                        headers: {
                            'Authorization': `Bearer ${loginStore.token}`
                        }
                    })

                } else {

                    // Chama a API para buscar os colaboradores da empresa
                    var response = await axios.get(`${API_BASE_URL}/administracao/carregaListaSetoresEmpresa/${idEmpresaRecebido.value}`, { 
                        params:{
                            textoBuscaSetoresEmpresa: textoBuscaSetoresEmpresa.value,
                            ordenacaoPor: ordenacaoPor || 'nome',  
                            direcaoOrdenacao: direcaoOrdenacao || 'asc',
                            paginaAtual: paginaAtual,
                            itensPorPagina: itensPorPagina
                        },
                        headers: {
                            'Authorization': `Bearer ${loginStore.token}`
                        }
                    })
                }

                // Formata os campos de valor monetário para padrão brasileiro
                const listaFormatada = response.data.data.map(item => ({
                    ...item
                }))

                // Agora atribui à sua lista reativa
                listaSetoresEmpresa.value = listaFormatada

                // Salva total de registros para mostrar na tabela
                totalSetoresEmpresa.value = response.data.total

                // Sinaliza que os produtos da empresa foram carregados
                carregandoSetoresEmpresa.value = false
            }

        } catch (erro) {

            // Sinaliza que os produtos da empresa foram carregados
            carregandoSetoresEmpresa.value = false

            // Usa a store de erros para exibir o erro
            erroStore.exibirErro(erro)

        } finally {
            carregandoSetoresEmpresa.value = false
        }
    }

    // Função para carregar os backups da empresa
    const carregarListaBackupsEmpresa = async () => {

        // Extrai parâmetros de forma segura e correta
        const opcoes = opcoesTabelaBackupsEmpresa.value

        // Ordenação - forma correta para Vuetify 3
        let ordenacaoPor = 'id'
        let direcaoOrdenacao = 'asc'

        if (opcoes.sortBy && opcoes.sortBy.length > 0) {
            ordenacaoPor = opcoes.sortBy[0].key
            direcaoOrdenacao = opcoes.sortBy[0].order
        }
        
        // Paginação
        const paginaAtual = opcoes.page || 1
        const itensPorPagina = opcoes.itemsPerPage || 10

        // Limpa a lista de backups
        listaBackupEmpresa.value = []
        totalBackupsEmpresa.value = 0

        try {

            // Verifica se já está em processo de carregamento
            if (carregandoBackupEmpresa.value == false){

                // Liga indicação de carga dos colaboradores
                carregandoBackupEmpresa.value = true
        
                // Chama a API para buscar os colaboradores da empresa
                const response = await axios.get(`${API_BASE_URL}/administracao/carregaListaBackups/${idEmpresaRecebido.value}`, { 
                    params:{
                        textoBuscaBackupEmpresa: textoBuscaBackupEmpresa.value,
                        ordenacaoPor: ordenacaoPor || 'id',  
                        direcaoOrdenacao: direcaoOrdenacao || 'asc',
                        paginaAtual: paginaAtual,
                        itensPorPagina: itensPorPagina
                    },
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Atualiza os dados dos colaboradores e o total
                listaBackupEmpresa.value = response.data.data

                // Salva total de 
                totalBackupsEmpresa.value = response.data.total

                // Desliga indicação de carga dos colaboradores
                carregandoBackupEmpresa.value = false        
            }

        } catch (erro) {

            // Desliga indicação de carga dos colaboradores
            carregandoBackupEmpresa.value = false  

            // Usa a store de erros para exibir o erro
            erroStore.exibirErro(erro)

        } finally {
            carregandoBackupEmpresa.value = false
        }
    }

    // Esta função é chamada ao se digitar o custo de do chamado para formatar o valor em BR
    const formatarCusto = (event, campo) => {
        
        // Busca valor digitado
        const valorDigitado = event.target.value
        
        // Formata valor
        const valorFormatado = proxy.$formatarDinheiro(valorDigitado)

        if (campo === 'precoTabela') {
            modalDadosProdutoEmpresa.value.data.precoTabela = valorFormatado
        } else if (campo === 'precoTotal') {
            modalDadosProdutoEmpresa.value.data.precoTotal = valorFormatado
        }        
    }

    // Limpa dados do formulário modal colaborador empresa
    const limpaModalDadosColaboradorEmpresa = () => {

        modalDadosColaboradorEmpresa.value = {
            modo: 'novo',
            data: {
                id: 0,
                idEmpresa: idEmpresaRecebido.value,
                listaSetores: [],
                idSetor: null,
                nome: '',
                login: '',
                senha: '',
                confereSenha: '',
                cargo: '',  
                sexo: '',
                email: '',
                telefone: '',
                pontuacaoInicial: '',
                valorHora: 'R$ 0,00',
                cinegrafista: false,
                tecnico: false,
                motorista: false,
                administrador: false,
                liberador: false,
                reporter: false,
                ativo: true
            }
        }
    }

    // Função para buscar o preço quando um produto é selecionado
    const buscarPrecoProduto = (idProdutoSelecionado) => {

        // Se não recebeu o idProdutoSelecionado sai da rotina
        if (!idProdutoSelecionado) return
        
        // Encontra o produto selecionado no array
        const produtoSelecionado = modalDadosProdutoEmpresa.value.data.produtoEmpresa
            .find(produto => produto.value === idProdutoSelecionado)
        
        // Se encontrou o produto, atualiza o preço
        if (produtoSelecionado) {

            modalDadosProdutoEmpresa.value.data.precoTabela = produtoSelecionado.precoTabela.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });

            // Calcula o preço total do produto selecionado
            calcularPrecoTotal()            
        }        
    }

    // Esta rotina abre o modal de confirmação
    const abreModalConfirmacao = (index, origem, idBackup, idDiretorioBackup) => {

        if (origem === 'arquivos-upload'){

            // Seleciona a lista correta baseado no tipo
            let listaArquivos

            // Salva a lista de anexos dos chamados
            listaArquivos = arquivosAnexadosEmpresa.value

            // Valida se o índice existe
            if (index < 0 || index >= listaArquivos.length) {
                return
            }
            
            // Salva o arquivo selecionado
            const arquivo = listaArquivos[index]
            
            // Valida se o arquivo existe
            if (!arquivo) {
                return
            }
            
            // Define a mensagem baseada no tipo de arquivo
            const nomeArquivo = arquivo.name || 'Arquivo'
            
            modalMessage.value = arquivo.uniqueId 
                ? `Deseja Remover "${nomeArquivo}" do Servidor Permanentemente?`
                : `Deseja Remover "${nomeArquivo}" da Lista de Anexos?`
            
            // Guarda os dados pendentes
            pendingData.value = {
                index: index,
                arquivo: arquivo,
                tipo: arquivo,
                origem: 'arquivo',
                idBackup: null,
                idDiretorioBackup: null
            }
        
        } else if (origem === 'backups'){

            modalMessage.value = `Confirma Exclusão do Backup?`
            
            // Guarda os dados pendentes
            pendingData.value = {
                index: index,
                arquivo: null,
                origem: 'backups',
                idBackup: idBackup,
                idDiretorioBackup: null        
            }

        } else {
        
            // Guarda os dados pendentes
            pendingData.value = {
                index: index,
                arquivo: null,
                tipo: null,
                origem: 'diretorio-backups',
                idBackup: null,
                idDiretorioBackup: idDiretorioBackup
            }
        }
        
        // Abre o modal
        showModal.value = true
    }

    // Executa a remoção após confirmação
    const executarRemocao = async () => {

        if (pendingData.value.index !== null) {

            if (pendingData.value.origem == 'arquivo'){
            
                // Chama rotina de remoção passando o indice, arquivo e tipo
                await executaRemocaoAnexo(
                    pendingData.value.index
                )

            } else if (pendingData.value.origem === 'backups'){

                // Chama a rotina de exclusão de backups
                deleteExcluiBackup(pendingData.value.idBackup, pendingData.value.index)

            } else {

                // Chama rotina de exclusão de diretórios do backup
                deleteExcluiDiretoriosBackup(pendingData.value.idDiretorioBackup, pendingData.value.index)
            }

            // Limpa os dados pendentes
            pendingData.value = {
                index: null,
                arquivo: null,
                tipo: null,
                origem: null,
                idBackup: null,
                idDiretorioBackup: null
            }
        }
    }

    // Trata botão de confirmação do cancelamento
    const cancelarRemocao = () => {
        
        pendingData.value = {
            index: null,
            arquivo: null,
            tipo: null,
            origem: null,
            idBackup: null,
            idDiretorioBackup: null
        }
    }

    // Função real de remoção
    const executaRemocaoAnexo = async (index) => {

        // Define as configurações baseado no tipo
        const config =  {

            listaArquivos: arquivosAnexadosEmpresa,
            tabelaApi: 'anexos_empresa',
            mostraAnexosEmpresa: mostraAnexosEmpresa,
            nomeContexto: 'empresa'
        } 
        
        // Verifica se o índice ainda é válido
        if (index < 0 || index >= config.listaArquivos.value.length) return
        
        // Busca o arquivo atualizado na lista
        const arquivoParaRemover = config.listaArquivos.value[index]
        
        try {

            // Verifica se o arquivo já tem uniqueId (já salvo no servidor)
            if (arquivoParaRemover.uniqueId) {

                // Chama API para remover do servidor
                await axios.delete(
                    `${API_BASE_URL}/operacao/excluirArquivoAnexado/${arquivoParaRemover.uniqueId}/${config.tabelaApi}`,
                    {
                        headers: {
                            Authorization: `Bearer ${loginStore.token}`
                        }
                    }
                );
            }
            
            // Remove o arquivo da lista local
            config.listaArquivos.value.splice(index, 1)
            
            // Atualiza a lista de visualização se existir
            if (config.mostraAnexosEmpresa.value && typeof config.mostraAnexosEmpresa.value === 'object') {
                config.mostraAnexosEmpresa.value = [...config.listaArquivos.value]
            }            
            
        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    }

    // Limpa dados do formulário modal de backup
    const limpaDadosBackup = () => {

        modalDadosBackupEmpresa.value.data = {
            id: 0,
            idEmpresa: idEmpresaRecebido.value,
            servidor_origem: '',
            porta_servidor_origem: '',
            usuario_servidor_origem: '',
            senha_servidor_origem: '',
            chave_privada_origem: '',  
            servidor_destino: '',
            porta_servidor_destino: '',
            usuario_servidor_destino: '',
            senha_servidor_destino: '',
            chave_privada_destino: '',  
            ativo: true,
            diretorios: []
        }
    }

    // Limpa campos do cadastro de empresas
    function limpaDadosEmpresa(){

        dadosEmpresa.value = {
            modo: 'novo',
            data: {
                nomeFantasia: '',
                razaoSocial: '',
                apelido: '',
                custoHora: 'R$ 0,00',
                cnpj: '',
                inscricaoEstadual: '',
                inscricaoMunicipal: '',
                idRamoAtividade: [],
                idStatusCredito: [],
                urlSite: '',
                emailPrincipal: '',        
                fonePrincipal: '',
                pais: '',        
                cep: '',
                uf: '',
                cidade: '',
                bairro: '',
                logradouro: '',
                numero: '',
                complemento: '',
                empresaManutencao: false,
                emissoraTelevisao: false,
                arquivosAnexosEmpresa: [],
                ativo: true
            }
        } 
        
        // Limpa id da empresa recebido da lista
        idEmpresaRecebido.value = 0;
    }

    // Limpa dados do formulário modal produtos empresa
    function limpaModalDadosProdutoEmpresa(){

        Object.assign(modalDadosProdutoEmpresa.value.data, {
            id: 0,
            idEmpresa: idEmpresaRecebido.value,
            idProdutoEmpresa: [],
            produtoEmpresa: [],
            precoTabela: '',
            quantidadeLicencas: '',
            precoTotal: '',
            ativo: true
        })

        modalDadosProdutoEmpresa.value.visible = true
    }

    // Limpa dados do formulário modal de setores da empresa
    function limpaDadosModalSetoresEmpresa(){

        Object.assign(modalDadosSetoresEmpresa.value.data, {
            id: 0,
            idEmpresa: idEmpresaRecebido.value,
            nome: '',
            externa: false,
            almoxarifado: false,
            manutencao: false,
            ativo: true
        })       
    }

    // Limpa dados do formulário modal dos diretórios do backup
    function limpaDadosDiretoriosBackup(){

        Object.assign(modalDiretoriosBackup.value.data, {
            id: 0,
            idBackup: modalDadosBackupEmpresa.value.data.idBackup,
            diretorio_origem: '',
            diretorio_destino: '/home/storage2/1/a8/c0/suita2',
            tempo_permanencia: 3
        })
    }

    // Fecha modal do cadastro de colaboradores
    function fecharModalColaborador(){

        // Torna modal invisível
        modalDadosColaboradorEmpresa.value.visible = false
        
        // Limpa dados do modal
        limpaModalDadosColaboradorEmpresa()
    }

    // Fecha modal do cadastro de colaboradores
    function fecharModalProdutoEmpresa(){

        // Limpa dados do modal
        limpaModalDadosProdutoEmpresa()
        
        // Torna modal invisível
        modalDadosProdutoEmpresa.value.visible = false 
    }

    // Fecha modal do cadastro de setores da empresa
    function fecharModalSetoresEmpresa(){

        // Limpa dados do modal setores
        limpaDadosModalSetoresEmpresa()

        // Torna modal sertores invisível
        modalDadosSetoresEmpresa.value.visible = false
    }

    // Fecha modal do cadastro de backups
    function fecharModalBackupEmpresa(){

        limpaDadosBackup()

        modalDadosBackupEmpresa.value.visible = false
    }

    // Fecha modal dos diretórios da empresa
    function fecharModalDiretoriosBackupEmpresa(){

        // Limpa dados do formulário de cadastro de backup
        limpaDadosDiretoriosBackup()

        // Torna formulário invisível
        modalDiretoriosBackup.value.visible = false
    }

    // Se o campo foi limpo, recarrega a lista de colaboradores        
    function onBuscaColaboradorAtualizada(novoValor) {
        if (!novoValor) {
            carregarListaColaboradoresEmpresa()
        }
    }

    // Se o campo foi limpo, recarrega a lista de produtos
    function atualizaParamentrosBuscaProdutosEmpresa(novoValor){
        if (!novoValor){
            carregarListaProdutosEmpresa()
        }
    }

    // Se o campo foi limpo, recarrega a lista de produtos
    function atualizaParamentrosBuscaSetoresEmpresa(novoValor){
        if (!novoValor){
            carregarListaSetoresEmpresa()
        }
    }

    // Se o campo foi limpo, recarrega a lista de dados de backup        
    function onBuscaBackupsAtualizada(novoValor) {
        if (!novoValor) {
            carregarListaBackupsEmpresa()
        }
    }

    // Função simples para formatar como moeda o custo da hora da empresa
    function formatarValorCustoHora(event) {

        // Busca valor digitado no elemento
        const valorBruto = event.target.value.replace(/\D/g, '');

        // Verifica se recebeu valor bruto
        if (!valorBruto) {
            dadosEmpresa.value.custoHora = '';
            return;
        }

        // Converte o valor digitado para começar pelas centenas
        const valorConvertido = parseFloat(valorBruto) / 100;
        
        // Mostra o valor convertido com a mascara para brasil
        dadosEmpresa.value.custoHora = valorConvertido.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    }

    // Função simples para formatar como moeda
    function formatarValorColaborador(event) {

        // Busca valor digitado no elemento
        const valorBruto = event.target.value.replace(/\D/g, '');

        // Verifica se recebeu valor bruto
        if (!valorBruto) {
            modalDadosColaboradorEmpresa.value.data.valorHora = '';
            return;
        }

        // Converte o valor digitado para começar pelas centenas
        const valorConvertido = parseFloat(valorBruto) / 100;
        
        // Mostra o valor convertido com a mascara para brasil
        modalDadosColaboradorEmpresa.value.data.valorHora = valorConvertido.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    }

    // Esta função valida o campo cnpj
    function validarCnpj(cnpj){

        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj.length !== 14) {
            
            snackbar.trigger('CNPJ Inválido. Deve Conter 14 Digitos', 'error');
            focoCNPJ.value.focus()
            return false;
        }

        // Elimina CNPJs inválidos conhecidos
        if (/^(\d)\1+$/.test(cnpj)) {
            
            snackbar.trigger('CNPJ Inválido.', 'error');
            focoCNPJ.value.focus()
            return false;
        }

        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }

        let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(0)) {

            snackbar.trigger('CNPJ Inválido.', 'error');
            focoCNPJ.value.focus()
            return false;
        }

        tamanho += 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }

        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        return resultado == digitos.charAt(1);
    }

    // Função para buscar o endereço pelo CEP usando a API do ViaCEP
    function buscaCep(cep) {

        // Remove qualquer caracter que não seja número
        const cepLimpo = cep.replace(/\D/g, '');

        // Verifica se o CEP possui 8 dígitos
        if (cepLimpo.length === 8) {
            
            // Chama a API do ViaCEP para buscar os dados do endereço
            axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`).then(response => {
                
                const dados = response.data;
                    
                if (!dados.erro) {
                
                    // Preenche os campos do endereço com os dados retornados                
                    dadosEmpresa.value.logradouro = dados.logradouro.toUpperCase();                
                    dadosEmpresa.value.bairro = dados.bairro.toUpperCase();                
                    dadosEmpresa.value.cidade = dados.localidade.toUpperCase();                
                    dadosEmpresa.value.uf = dados.uf.toUpperCase();                
                    dadosEmpresa.value.pais = 'BRASIL';

                    focoNumero.value.focus()
                
                } else {
                
                    // CEP não encontrado
                    snackbar.trigger('CEP não encontrado.', 'error');
                }
                
            }).catch(erro => {                
                erroStore.exibirErro(erro)
            });
        
        } else {

            // CEP inválido
            snackbar.trigger('CEP inválido. Deve conter 8 dígitos.', 'error');            
        }
    }

    // Função que lê o tamanho da barra no localStorage e aplica na 
    function ajustaBarraPretaTopo(){
        
        if (localStorage.getItem('tamanhoBarraLaterar') == 'true'){
            modoBarraLateral.value = true
        } else{
            modoBarraLateral.value = false
        }
    }

    // Limita o valor de campos numéricos
    function limitarTamanho(evento, maximo) { 
        
        // Busca valor do evento gerado pelo input e filtra somente números
        let valor = String(evento.target.value).replace(/\D/g, ''); 
        valor = valor.slice(0, maximo);
        
        // Garante só números if (valor.length > 5) 
        valor = valor.slice(0, maximo); 
        modalDadosColaboradorEmpresa.value.data.pontuacaoInicial = valor; 
        e.target.value = valor;
    }
    
    // Busca dados do colaborador e mostra em um formulário modal
    async function editarColaboradorEmpresa(idColaborador){

        try{

            // Limpa dados do formulário        
            limpaModalDadosColaboradorEmpresa()

            // Busca os dados do chamado específico por idChamado
            const { data: respostaApi } = await axios.get(`${API_BASE_URL}/administracao/carregaColaborador/${idColaborador}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Verifica se retornou dados da API
            if (respostaApi) {

                // Salva os dados do colaborador retornados pela api
                modalDadosColaboradorEmpresa.value = {
                    visible: true,
                    modo: 'edicao',
                    data: {
                        ...respostaApi.data,
                        sexo: Number(respostaApi.data.sexo)
                    }
                }
                
                // Mostra o valor hora técnica do colaborador
                modalDadosColaboradorEmpresa.value.data.valorHora = Number(respostaApi.data.valorHora).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                // Converte os campos TINYINT(1) para booleanos
                modalDadosColaboradorEmpresa.value.data.ativo = modalDadosColaboradorEmpresa.value.data.ativo == 1
                modalDadosColaboradorEmpresa.value.data.administrador = modalDadosColaboradorEmpresa.value.data.administrador == 1
                modalDadosColaboradorEmpresa.value.data.liberador = modalDadosColaboradorEmpresa.value.data.liberador == 1
                modalDadosColaboradorEmpresa.value.data.cinegrafista = modalDadosColaboradorEmpresa.value.data.cinegrafista == 1
                modalDadosColaboradorEmpresa.value.data.motorista = modalDadosColaboradorEmpresa.value.data.motorista == 1
                modalDadosColaboradorEmpresa.value.data.reporter = modalDadosColaboradorEmpresa.value.data.reporter == 1
                modalDadosColaboradorEmpresa.value.data.tecnico = modalDadosColaboradorEmpresa.value.data.tecnico == 1
                
            } else {
                erroStore.exibirErro('Colaborador não encontrado')
            }

        } catch(erro){            
            erroStore.exibirErro(erro)
        }
    }
    
    // Busca dados do colaborador e mostra em um formulário modal
    async function editarProdutoEmpresa(idProduto){

        try{

            // Limpa dados do formulário        
            limpaModalDadosProdutoEmpresa()

            // Carrega todos produtos
            const { data: dataProdutos } = await axios.get(`${API_BASE_URL}/administracao/carregaListaProdutos`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Garante que temos um array válido de produtos
            const produtos = Array.isArray(dataProdutos.data) 
                ? dataProdutos.data 
                : dataProdutos.data || []

            // Filtra apenas produtos ativos (ativo = 1)
            const produtosAtivos = produtos.filter(produto => produto.ativo === 1)

            // Carrega os produtos ATIVOS no formato que o v-select precisa
            modalDadosProdutoEmpresa.value.data.produtoEmpresa = produtosAtivos.map(produto => ({
                value: produto.idProduto,
                title: produto.nome
            }))

            // Busca os produtos da empresa
            const { data: respostaApi } = await axios.get(`${API_BASE_URL}/administracao/carregaProdutoEmpresa/${idProduto}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Verifica se retornou dados da API
            if (respostaApi) {

                // Carrega o id do produto empresa
                modalDadosProdutoEmpresa.value.data.id = respostaApi.data.id

                // Converte o campo TINYINT(1) ativo para booleano
                modalDadosProdutoEmpresa.value.data.ativo = respostaApi.data.ativo == 1 ? true : false

                // Aponta para o produto selecionado
                modalDadosProdutoEmpresa.value.data.idProdutoEmpresa = respostaApi.data.idProdutoEmpresa
                
                // Carrega os dados do modal Produtos Empresa
                modalDadosProdutoEmpresa.value.data.quantidadeLicencas = respostaApi.data.quantidadeLicencas
                
                // Carrega o preço de tabela licença
                modalDadosProdutoEmpresa.value.data.precoTabela = Number(respostaApi.data.precoTabela).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                // Carrega o preço total
                modalDadosProdutoEmpresa.value.data.precoTotal = Number(respostaApi.data.precoTotal).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                // Mostra modal de produtos da empresa
                modalDadosProdutoEmpresa.value.visible = true

            } else {
                erroStore.exibirErro('Colaborador não encontrado')
            }

        } catch(erro){            
            erroStore.exibirErro(erro)
        }
    }

    // Busca dados do colaborador e mostra em um formulário modal
    async function editarSetorEmpresa(idSetor){

        try{

            // Limpa dados do formulário        
            limpaDadosModalSetoresEmpresa()

            // Busca os dados do chamado específico por idChamado
            const { data: respostaApi } = await axios.get(`${API_BASE_URL}/administracao/carregaSetor/${idSetor}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Verifica se retornou dados da API
            if (respostaApi) {

                // Salva os dados do colaborador retornados pela api
                modalDadosSetoresEmpresa.value = {
                    visible: true,
                    data: {
                        ...respostaApi.data,
                    }
                }
                
                // Converte os campos TINYINT(1) para booleanos
                modalDadosSetoresEmpresa.value.data.externa = modalDadosSetoresEmpresa.value.data.externa == 1
                modalDadosSetoresEmpresa.value.data.almoxarifado = modalDadosSetoresEmpresa.value.data.almoxarifado == 1
                modalDadosSetoresEmpresa.value.data.manutencao = modalDadosSetoresEmpresa.value.data.manutencao == 1
                modalDadosSetoresEmpresa.value.data.ativo = modalDadosSetoresEmpresa.value.data.ativo == 1

            } else {
                erroStore.exibirErro('Colaborador não encontrado')
            }

        } catch(erro){            
            erroStore.exibirErro(erro)
        }
    }
    
    // Busca dados do backup e mostra no formulário modal
    async function carregaDadosBackup(idBackup){
        
        try{

            // Limpa dados do formulário        
            limpaDadosBackup()

            // Busca os dados do chamado específico por idChamado
            const { data: respostaApi } = await axios.get(`${API_BASE_URL}/administracao/carregaBackup/${idBackup}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Verifica se retornou dados da API
            if (respostaApi) {

                // Salva os dados do colaborador retornados pela api
                modalDadosBackupEmpresa.value = {
                    visible: true,
                    data: {
                        ...respostaApi,
                    }
                }
                
                // Converte o campo TINYINT(1) ativo para booleano
                modalDadosBackupEmpresa.value.data.ativo = respostaApi.ativo == 1 ? true : false

            } else {
                erroStore.exibirErro('Backup não encontrado')
            }

        } catch(erro){            
            erroStore.exibirErro(erro)
        }
    }

    // Busca dados do diretório backup da empresa
    async function editarDiretorioBackupEmpresa(index){
       
        // Busca o diretório na lista pelo índice
        const diretorio = modalDadosBackupEmpresa.value.data.diretorios[index]
        
        if (!diretorio) {
            snackbar.trigger('Diretório não encontrado!', 'error')
            return
        }

        // ✅ Salva o índice para usar no salvamento
        modalDiretoriosBackup.value.editIndex = index

        // Preenche o modal com os dados
        modalDiretoriosBackup.value = {
            visible: true,
            editIndex: index,  // ⭐ Guarda o índice para edição
            data: {
                id: diretorio.id || 0,
                diretorio_origem: diretorio.diretorio_origem || '',
                diretorio_destino: diretorio.diretorio_destino || '',
                tempo_permanencia: diretorio.tempo_permanencia,
                ativo: diretorio.ativo === 1 || diretorio.ativo === true
            }
        }
    }

    // Exclui um diretório do backup
    async function deleteExcluiDiretoriosBackup(idDiretorio, index){

        try{
        
            // Chama api para excluir diretório do backup
            const { respostaApi } = await axios.delete(`${API_BASE_URL}/administracao/deleteExcluiDiretoriosBackup/${idDiretorio}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Remove diretório da tabela
            modalDadosBackupEmpresa.value.data.diretorios.splice(index, 1)

            // Atualiza total de registros
            totalDiretoriosBackupsEmpresa.value = modalDadosBackupEmpresa.value.data.diretorios.length
            
        } catch(erro){
            erroStore.exibirErro(erro)
        }
    }

    // Exclui backup
    async function deleteExcluiBackup(idBackup, index){

        try{
        
            // Chama api para excluir diretório do backup
            const { respostaApi } = await axios.delete(`${API_BASE_URL}/administracao/deleteExcluiBackup/${idBackup}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Remove pelo índice
            listaBackupEmpresa.value.splice(index, 1)
            totalBackupsEmpresa.value = listaBackupEmpresa.value.length
            
        } catch(erro){
            erroStore.exibirErro(erro)
        }

    }

    // Retorna para a lista de empresas
    function funcaoRetornar() {
        channel.postMessage('atualizar-lista')
        window.close()
    }

    // Regra personalizada para validar campos
    async function validarSalvarEmpresa(funcaoRetorno) {
        
        // Valida o formulário de empresa
        const isValid = await formCadastroEmpresa.value?.validate()

        // Se o formulário for válido chama a função para salvar os dados
        if (isValid.valid) {

            // Chama a função para salvar os dados da empresa
            salvarDadosEmpresa(funcaoRetorno)

        } else {            
            snackbar.trigger('Preencha os campos obrigatórios.', 'error');
        }
    }

    // Esta função salva ou edita os dados de uma empresa
    async function salvarDadosEmpresa(funcaoRetorno) {

        try {
            
            // Se a variável urlSite não possuir especificação http insere
            if (!dadosEmpresa.value.urlSite.startsWith('http')) {
                dadosEmpresa.value.urlSite = 'https://' + dadosEmpresa.value.urlSite
            }

            // Executa upload dos arquivos anexados e obtém os dados dos arquivos salvos no servidor
            const resultadoUpload = await uploadArquivos(arquivosAnexadosEmpresa, {

                token: loginStore.token,
                onProgress: (progresso) => {
                    
                    // Atualiza o progresso para mostrar no v-progress-linear
                    uploadProgressEmpresa.value = progresso.percentual;
                }
            });
            
            // Se upload não retornou erro, salva os dados dos arquivos anexados
            if (resultadoUpload.status != 'erro') {

                // Extrai apenas os dados necessários
                const dadosAnexos = arquivosAnexadosEmpresa.value.map(arquivo => ({
                    filePath: arquivo.filePath,
                    filename: arquivo.filename,
                    originalName: arquivo.originalName,
                    size: arquivo.size,
                    serverName: arquivo.serverName,
                    uniqueId: arquivo.uniqueId          
                }));

                // Salva os dados dos arquivos anexados
                dadosEmpresa.value.arquivosAnexosEmpresa = dadosAnexos;  

            } else {
                dadosEmpresa.value.arquivosAnexosEmpresa = []
            }

            // Busca o ID da empresa para saber se é inclusão ou edição
            const {data: resposta } = await axios.post(`${API_BASE_URL}/administracao/salvaEmpresa/${idEmpresaRecebido.value}`, dadosEmpresa.value, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Atualiza o idEmpresa com o valor retornado da API
            idEmpresaRecebido.value = resposta.idEmpresa;

            // Exibe mensagem de sucesso
            snackbar.trigger('Empresa Salva Com Sucesso.', 'success');

            if (funcaoRetorno == 'salvar'){
                return
            } else if (funcaoRetorno == 'salvar-retornar'){
                funcaoRetornar()
            } else {
                limpaDadosEmpresa()
            }

        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    } 
    
    // Regra personalizada para validar campos
    async function validarSalvarColaborador(funcaoRetorno) {
        
        // Valida o formulário de colaborador
        const isValid = await formCadastroColaboradorEmpresa.value?.validate()

        // Se o formulário for válido chama a função para salvar os dados
        if (isValid.valid) {

            // Chama a função para salvar os dados do colaborador
            salvarDadosColaboradorEmpresa(funcaoRetorno)

        } else {
            
            // Exibe mensagem de sucesso
            snackbar.trigger('Preencha os campos obrigatórios.', 'error');            
        }
    }

    // Esta função salva os dados do colaborador da empresa selecionada
    async function salvarDadosColaboradorEmpresa(funcaoRetorno) {

        try{
        
            // Valida a senha informada se estiver criando um novo colaborador
            if (modalDadosColaboradorEmpresa.value.modo == 'novo'){

                // Valida a senha
                const validacao = senhaStore.validarSenha(modalDadosColaboradorEmpresa.value.data.senha)
            
                // Testa se a senha está nos padrões exigidos
                if (!validacao.valida) {

                    const mensagem = validacao.erros.map(item => `• ${item}`).join('\n')
                    erroStore.exibirErro(mensagem)
                    return
                }
            }
            
            // Chama api para salvar colaborador
            const {data: resposta } = await axios.post(`${API_BASE_URL}/administracao/salvaColaborador`, modalDadosColaboradorEmpresa.value.data, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Salva id do colaborador
            modalDadosColaboradorEmpresa.value.data.id = resposta.idColaborador
            
            // Recarrega a lista de colaboradores
            carregarListaColaboradoresEmpresa()

            // Exibe mensagem de sucesso
            snackbar.trigger('Colaborador Salvo Com Sucesso.', 'success');

            // Identifica qual o botão que foi pressionado para salvar e executa a função
            if (funcaoRetorno == 'salvar'){
                return
            } else if (funcaoRetorno == 'salvar-retornar'){
                fecharModalColaborador()
            } else {
                novoColaborador()
            }
            
        } catch(erro){
            erroStore.exibirErro(erro)
        }        
    }
    
    // Regra personalizada para validar campos do formulário de produtos da empresa
    async function validarSalvarProdutoEmpresa(funcaoRetorno) {
        
        // Valida o formulário de colaborador
        const isValid = await formCadastroProdutoEmpresa.value?.validate()

        // Se o formulário for válido chama a função para salvar os dados
        if (isValid.valid) {

            // Chama a função para salvar os dados do colaborador
            salvarDadosProdutoEmpresa(funcaoRetorno)

        } else {
            
            // Exibe mensagem de sucesso
            snackbar.trigger('Preencha os campos obrigatórios.', 'error');            
        }
    }

    // Esta função salva os dados do produto da empresa selecionada
    async function salvarDadosProdutoEmpresa(funcaoRetorno) {

        try{
        
            // Chama api para salvar colaborador
            const { data } = await axios.post(`${API_BASE_URL}/administracao/salvaProdutoEmpresa`, modalDadosProdutoEmpresa.value.data, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Recarrega a lista de colaboradores
            carregarListaProdutosEmpresa()

            // Exibe mensagem de sucesso
            snackbar.trigger('Produto Salvo Com Sucesso.', 'success');

            // Identifica qual o botão que foi pressionado para salvar e executa a função
            if (funcaoRetorno == 'salvar'){
                return
            } else if (funcaoRetorno == 'salvar-retornar'){
                fecharModalProdutoEmpresa()
            } else {
                novoProdutoEmpresa()
            }
            
        // Mostra erro            
        } catch(erro){
            erroStore.exibirErro(erro)
        }        
    }    

    // Regra personalizada para validar campos do formulário dos setores da empresa
    async function validarSalvarSetoresEmpresa(funcaoRetorno) {
        
        // Valida formulário de setores
        const isValid = await formCadastroSetoresEmpresa.value?.validate()

        // Se o formulário for válido chama a função para salvar os dados
        if (isValid.valid) {

            // Chama a função para salvar os dados do colaborador
            salvarDadosSetorEmpresa(funcaoRetorno)

        } else {
            
            // Exibe mensagem de sucesso
            snackbar.trigger('Preencha os campos obrigatórios.', 'error');            
        }
    }
    
    // Função para salvar os dados do setor da empresa
    async function salvarDadosSetorEmpresa(funcaoRetorno) {

        try{
        
            // Chama api para salvar colaborador
            const { data } = await axios.post(`${API_BASE_URL}/administracao/salvaSetorEmpresa`, modalDadosSetoresEmpresa.value.data, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Recarrega a lista de colaboradores
            carregarListaSetoresEmpresa()

            // Exibe mensagem de sucesso
            snackbar.trigger('Setor Salvo Com Sucesso.', 'success');

            // Identifica qual o botão que foi pressionado para salvar e executa a função
            if (funcaoRetorno == 'salvar'){
                return
            } else if (funcaoRetorno == 'salvar-retornar'){
                fecharModalSetoresEmpresa()
            } else {
                limpaDadosModalSetoresEmpresa()
            }
            
        // Mostra erro            
        } catch(erro){
            erroStore.exibirErro(erro)
        }  
        
    }

    // Regra personalizada para validar campos do formulário dos backups da empresa
    async function validarSalvarBackupsEmpresa(funcaoRetorno){

        // Valida formulário de setores
        const isValid = await formCadastroBackupsEmpresa.value?.validate()

        // Se o formulário for válido chama a função para salvar os dados
        if (isValid.valid) {

            // Chama a função para salvar os dados do colaborador
            salvarDadosBackupEmpresa(funcaoRetorno)

        } else {
            
            // Exibe mensagem de sucesso
            snackbar.trigger('Preencha os campos obrigatórios.', 'error');            
        }
    }

    // Função para salvar os dados do setor da empresa
    async function salvarDadosBackupEmpresa(funcaoRetorno) {

        try{
        
            // Chama api para salvar colaborador
            const { data } = await axios.post(`${API_BASE_URL}/administracao/salvaBackup`, modalDadosBackupEmpresa.value.data, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Salva o id do backup salvo no construtor para que a lista de diretórios de backup apareça
            modalDadosBackupEmpresa.value.data.id = data.idBackup
            
            // Carrega lista de backups
            carregarListaBackupsEmpresa()

            // Exibe mensagem de sucesso
            snackbar.trigger('Backup Salvo Com Sucesso.', 'success');

            // Identifica qual o botão que foi pressionado para salvar e executa a função
            if (funcaoRetorno == 'salvar'){
                return
            } else if (funcaoRetorno == 'salvar-retornar'){
                fecharModalBackupEmpresa()
            } else {
                limpaDadosDiretoriosBackup()
            }
            
        // Mostra erro            
        } catch(erro){
            erroStore.exibirErro(erro)
        } 
    }

    // Foca no campo dos diretório de origem ou destino
    const focarCampo = (campoRef) => {

        nextTick(() => {
        
            if (campoRef.value) {

                // Para Vuetify 3, o input está dentro do componente
                const input = campoRef.value.$el?.querySelector('input') || 
                            campoRef.value.$el?.querySelector('textarea')
                
                if (input) {
                    input.focus()
                    // Seleciona o texto (opcional)
                    input.select()
                } else {
                    // Fallback
                    campoRef.value.focus?.()
                }
            }
        })
    }

    // Verifica se o diretório já existe na lista
    const verificarDuplicataDiretorio = (diretorioOrigem, diretorioDestino, ignoreIndex = -1) => {

        const diretorios = modalDadosBackupEmpresa.value.data.diretorios || []
        
        // Verifica se a combinação ORIGEM + DESTINO já existe
        for (let i = 0; i < diretorios.length; i++) {
            // Ignora o índice que está sendo editado (se for edição)
            if (i === ignoreIndex) continue
            
            const dir = diretorios[i]
            
            // ✅ Verifica a combinação completa
            if (dir.diretorio_origem === diretorioOrigem && 
                dir.diretorio_destino === diretorioDestino) {
                return {
                    exists: true,
                    message: `A combinação "${diretorioOrigem}" → "${diretorioDestino}" já está cadastrada!`,
                    field: 'ambos'  // Ambos os campos
                }
            }
        }
        
        return { exists: false, message: '', field: '' }
    }

    // Função que valida os campos dos diretórios antes de inserir na lista
    async function validarSalvarDiretoriosBackupsEmpresa(funcaoRetorno) {

        try{

            // Valida o formulário
            const isValid = await formCadastroDiretoriosBackupsEmpresa.value?.validate()

            if (!isValid.valid) {
                snackbar.trigger('Preencha os campos obrigatórios.', 'error')
                return
            }

            const origem = modalDiretoriosBackup.value.data.diretorio_origem?.trim()
            const destino = modalDiretoriosBackup.value.data.diretorio_destino?.trim()
            const editIndex = modalDiretoriosBackup.value.editIndex

            // Verifica se é um novo registro
            if (modalDadosBackupEmpresa.value.data.id == 0){
            
                // Verifica se os diretórios fonte e destino já estão cadastrados
                const duplicata = verificarDuplicataDiretorio(origem, destino, editIndex)

                // Testa se existe duplicidade
                if (duplicata.exists) {
                    
                    // Mostra erro específico
                    snackbar.trigger(duplicata.message, 'error')
                    
                    // Foca no campo de origem (primeiro da combinação)
                    focarCampo(inputDiretorioOrigem)
                    return
                }
            }

            // Prepara os dados do novo diretório
            const novoDiretorio = {
                id: modalDiretoriosBackup.value.data.id || 0,
                diretorio_origem: origem,
                diretorio_destino: destino,
                tempo_permanencia: parseInt(modalDiretoriosBackup.value.data.tempo_permanencia)
            }

            // Insere ou atualiza
            if (editIndex !== undefined && editIndex !== null && editIndex !== -1) {

                modalDadosBackupEmpresa.value.data.diretorios[editIndex] = novoDiretorio
                modalDiretoriosBackup.value.editIndex = undefined

            } else {
                modalDadosBackupEmpresa.value.data.diretorios.push(novoDiretorio)                
            }

            // Atualiza o total
            totalDiretoriosBackupsEmpresa.value = modalDadosBackupEmpresa.value.data.diretorios.length

            // Chama api para salvar dados do backup
            const { data } = await axios.post(`${API_BASE_URL}/administracao/salvaBackup`, modalDadosBackupEmpresa.value.data, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Carrega lista de diretórios
            carregaDadosBackup(data.idBackup)
            
            // Salva o id do backup salvo no construtor para que a lista de diretórios de backup apareça
            modalDadosBackupEmpresa.value.data.id = data.idBackup
                
            snackbar.trigger('Diretório adicionado com sucesso!', 'success')
            
            // Ações pós-salvamento
            if (funcaoRetorno === 'salvar' || funcaoRetorno === 'editar') {
                return
            } else if (funcaoRetorno === 'salvar-retornar' || funcaoRetorno === 'editar-retornar') {
                fecharModalDiretoriosBackupEmpresa()
            } else {
                limpaDadosDiretoriosBackup()
                focarCampo(inputDiretorioOrigem)
            }

        } catch(erro){
            erroStore.exibirErro(erro)
        }
    }
    
    // Função para atualizar os checkboxes
    const atualizarCheckbox = (funcaoAtiva) => {
        
        // Se a função que foi clicada está sendo marcada como true
        if (modalDadosColaboradorEmpresa.value.data[funcaoAtiva] === true) {

            // Desmarca todas as outras
            funcoes.forEach(funcao => {
            
                if (funcao !== funcaoAtiva) {
                    modalDadosColaboradorEmpresa.value.data[funcao] = false
                }
            })
        }    
    }

    // Rotina chamada quando o componente é montado
    onMounted(async () => {

        try {
            
            // Listener para mudanças do drawer
            const manipuladorMudancaTamanho = (data) => {

                // Salva valor emitido pelo botão de minimizar/maximizar a barra lateral
                localStorage.setItem('tamanhoBarraLaterar', data)            
                
                // Ajusta barra preta do topo do formulário
                ajustaBarraPretaTopo(data)
            }
        
            // Adiciona listener para mudanças do drawer
            emitter.on('mudancaBarraLateral', manipuladorMudancaTamanho)

            // Ajusta a barra preta do topo do fomulário com o valor do localStorage
            ajustaBarraPretaTopo()
        
            // Busca todos ramos de atividade
            const ramosAtividade = await axios.get(`${API_BASE_URL}/administracao/carregaListaRamosAtividade`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Filtra apenas os ativos, se necessário
            listaRamosAtividade.value = ramosAtividade.data.data.filter(r => r.ativo === 1)

            // Busca todos status de crédito
            const statusCredito = await axios.get(`${API_BASE_URL}/administracao/carregaListaStatusCredito`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Filtra apenas os ativos, se necessário
            listaStatusCredito.value = statusCredito.data.data.filter(r => r.ativo === 1)

            // Verifica se foi recebid idEmpresaRecebido para carregar os dados da empresa
            if (idEmpresaRecebido.value != 0){

                // Busca dados da empresa pelo ID
                const { data: dadosRecebidos } = await axios.get(`${API_BASE_URL}/administracao/carregaEmpresa/${idEmpresaRecebido.value}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                // Atribui os dados da empresa à variável reativa dadosEmpresa
                dadosEmpresa.value = dadosRecebidos;

                // Verifica se a resposta é um array indicando que existem arquivos anexados
                if (Array.isArray(dadosEmpresa.value.arquivosAnexosEmpresa)) {

                    const arquivosExistentes = dadosEmpresa.value.arquivosAnexosEmpresa.map(arquivo => ({
                        filePath: arquivo.filePath,
                        filename: arquivo.filename,
                        originalName: arquivo.originalName,
                        size: arquivo.size,
                        serverName: arquivo.serverName,
                        uniqueId: arquivo.uniqueId,
                        isExisting: true,
                        displayName: `${arquivo.displayName || arquivo.originalName} (${(arquivo.size / 1024).toFixed(2)} KB)`,
                        raw: null
                    }));

                    arquivosAnexadosEmpresa.value = [
                        ...arquivosExistentes,
                        ...arquivosAnexadosEmpresa.value.filter(f => !f.isExisting)
                    ];

                    mostraAnexosEmpresa.value = arquivosAnexadosEmpresa.value.map(arquivoVfile => ({
                        name: arquivoVfile.originalName,
                        size: arquivoVfile.size,
                        type: 'application/octet-stream',
                        lastModified: Date.now()
                    }));

                    dadosEmpresa.value.arquivosAnexosEmpresa = mostraAnexosEmpresa.value;
                }
                
                // Mostra o valor hora técnica do colaborador
                dadosEmpresa.value.custoHora = Number(dadosEmpresa.value.custoHora).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                
                // Converte os campos empresa manutenção e ativo para booleanos
                dadosEmpresa.value.empresaManutencao = dadosEmpresa.value.empresaManutencao === 1;
                dadosEmpresa.value.emissoraTelevisao = dadosEmpresa.value.emissoraTelevisao === 1;
                dadosEmpresa.value.ativo = dadosEmpresa.value.ativo === 1;
            }

        } catch (erro) {
            erroStore.exibirErro(erro)
        }        
    })

    // Limpar o timer quando o componente for destruído
    onBeforeUnmount(() => {

        // Limpar listener
        emitter.off('mudancaBarraLateral')
    })

    // Observa mudanças no acordeon colaboradores para carregar os mesmos
    watch(acordeonColaboradores, (val) => {
        
        if (Array.isArray(val)) {
            
            if (val.includes(0)) {
                carregarListaColaboradoresEmpresa()
            }
            
        } else if (val === 0) {
            carregarListaColaboradoresEmpresa()
        } else {
            totalColaboradores.value = 0
        }
    })

    // Observa mudanças no acordeon empresa para carregar os mesmos
    watch(acordeonProdutosEmpresa, (val) => {
        
        if (Array.isArray(val)) {
            
            if (val.includes(0)) {
                carregarListaProdutosEmpresa()
            }
            
        } else if (val === 0) {
            carregarListaProdutosEmpresa()
        } else {
            totalProdutosEmpresa.value = 0
        }
    })

    // Observa mudanças no acordeon setores para carregar os mesmos
    watch(acordeonSetoresEmpresa, (val) => {
        
        if (Array.isArray(val)) {
            
            if (val.includes(0)) {
                carregarListaSetoresEmpresa()
            }
            
        } else if (val === 0) {
            carregarListaSetoresEmpresa()
        } else {
            totalSetoresEmpresa.value = 0
        }
    })
    
    // Observa mudanças no acordeon de backups da empresa
    watch(acordeonBackupEmpresa, (val) => {

        if (Array.isArray(val)) {
            
            if (val.includes(0)) {
                carregarListaBackupsEmpresa()
            }
            
        } else if (val === 0) {
            carregarListaBackupsEmpresa()
        } else {
            totalBackupsEmpresa.value = 0
        }
    })
    
    // Watch para detectar quando o modal abre/fecha
    watch(() => modalDadosColaboradorEmpresa.value.visible, async (novaVisibilidade) => {

        if (novaVisibilidade) {
            
            try {

                if (loginStore.emissoraTelevisao == 0){
                
                    // Busca departamentos cadastrados
                    var respostaApi = await axios.get(`${API_BASE_URL}/administracao/carregaListaDepartamentos`, { 
                        params:{
                            textoBuscaSetoresEmpresa: "",
                            ordenacaoPor: 'nome',  
                            direcaoOrdenacao: 'asc',
                            paginaAtual: 1,
                            itensPorPagina: -1
                        },
                        headers: {
                            'Authorization': `Bearer ${loginStore.token}`
                        }
                    })

                } else {

                    // Busca setores cadastrados
                    var respostaApi = await axios.get(`${API_BASE_URL}/administracao/carregaListaSetoresEmpresa/${loginStore.idEmpresa}`, {
                        headers: {
                            Authorization: `Bearer ${loginStore.token}`
                        }
                    })

                }

                // Pega o objeto retornado
                const setorObjeto = respostaApi.data.data // ou respostaApi.data, dependendo da estrutura

                // Converte para array com 1 elemento
                modalDadosColaboradorEmpresa.value.data.listaSetores = setorObjeto

            } catch (erro) {
                erroStore.exibirErro('Erro ao carregar setores: ' + erro.message)    
            }

        } else {
            limpaModalDadosColaboradorEmpresa()
        }
    })
    
    // Watch chamado pelo v-switch externa para desativar almoxarifado e manutenção
    watch(
        () => modalDadosSetoresEmpresa.value.data.externa,
        (newVal) => {
            if (newVal) {
            modalDadosSetoresEmpresa.value.data.almoxarifado = false
            modalDadosSetoresEmpresa.value.data.manutencao = false
            }
        }
    )

    // Watch chamado pelo v-switch almoxarifado para desativar externa e manutenção
    watch(
        () => modalDadosSetoresEmpresa.value.data.almoxarifado,
        (newVal) => {
            if (newVal) {
            modalDadosSetoresEmpresa.value.data.externa = false
            modalDadosSetoresEmpresa.value.data.manutencao = false
            }
        }
    )

    // Watch chamado pelo v-switch manutencao para desativar externa e almoxarifado
    watch(
    () => modalDadosSetoresEmpresa.value.data.manutencao,
        (newVal) => {
            if (newVal) {
            modalDadosSetoresEmpresa.value.data.externa = false
            modalDadosSetoresEmpresa.value.data.almoxarifado = false
            }
        }
    )       
    
</script>

<style scoped>
    .checkboxes-horizontal {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
    }
</style>

<style>
    .cursor-pointer {
        cursor: pointer;
    }
    .cursor-pointer:hover {
        opacity: 0.8;
    }    
</style>